// 'use strict';

// Import stylesheets
import './style.css';

// import NProgress from "./tonejs-instruments-master/external-js/nprogress.js"
// import SampleLibrary from "./tonejs-instruments-master/Tonejs-Instruments.js"
//import SampleLibrary from './instruments.js'
import { midiFreqs, midiPitches, convertToSharp } from "./midiData.js"
import { timeSignatureToBeatsPerMeasure, baseTempo, noteLengthToTimeValue } from "./timeSignatureData.js"
import instrumentData from "./instrumentData.js"
import MusicXMLAgent from "./MusicXMLAgent.js"
import LocalSnapLogger from "./LocalSnapLogger.js"
import customInstrumentData from "./customInstrumentData";
import SnapURLSynchronizer from "./SnapURLSynchronizer"
import GuideFrameFactory from "./GuideFrames/GuideFrameFactory"
import AbcAIAgent from "./AbcAIAgent"
import BlockBuilder from "./BlockBuilder";
import SongSearch from "./SongSearch.js";
import * as util from "./util.js";
import firebase from "firebase/app";
import "firebase/firestore";
//import WebMidi from "webmidi"


const guideFrameFactory = new GuideFrameFactory();

// import Tone from "./tonejs-instruments-master/external-js/Tone.js"
var introJs = require('intro.js')
var Tone = require('tone')
var $ = require('jquery')

var aws = require('aws-sdk')
const { WebMidi } = require("webmidi");

var webaudiofont = require('webaudiofont');

var List = window.SnapList;
var menuCollapsed = false;
// var iSnapRequire = require("./iSnap/")
// console.log(iSnapRequire)
console.log("in index");


// CONFIG
let snapMode = "isnap" // isnap, snap4arduino, snap; currently not used because of separate sources
let SnapProjectName = "TuneScope.xml" // TODO: add custom created from snap4arduino to prevent error message
let defaultScreenName = "Snap" // Manually change order of adding modes if changing this

// CREDENTIALS
let accessKeyId = 'AKIAUQTGI5RKX7OW4JF7'
let secretAccessKey = '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'

// MusicXML Initialization
let musicXMLAgent = new MusicXMLAgent();

//SongSearch Initialization
let songSearch = new SongSearch();

// Firebase initialization
var firebaseConfig = {
    apiKey: 'AIzaSyDQofNHPZ9QYspHR9ffKTYn7U9NnW-CL6s',
    authDomain: 'tune-scope.firebaseapp.com',
    databaseURL: 'https://tune-scope.firebaseio.com',
    projectId: 'tune-scope',
    storageBucket: 'tune-scope.appspot.com',
    messagingSenderId: '111069830451'
};
firebase.initializeApp(firebaseConfig)
const db = firebase.firestore();

const wait = (duration) => {
    return new Promise((resolve, reject) => {
        setTimeout(() => {
            resolve();
        }, duration)
    })
}

// MIDI Communication

class MidiCommunicator {
    constructor() {
        /*
        console.log(navigator);
        navigator.requestMidiAccess().then((midiAccess) => {
            console.log(midiAccess);

            var inputs = midiAccess.inputs;
            var outputs = midiAccess.outputs;
        }).catch((err) => {
            console.log('Could not access your MIDI devices.');
        })

         */
    }

    sendMidi = (midiFreq, duration) => {

    }

    onPlayNote = (midiFreq, duration) => {
        // TODO: decide whether to play
        this.sendMidi(midiFreq, duration);
    }
}

let midiCommunicator = new MidiCommunicator();

// Logging


class AWSLogger {
    constructor() {
        aws.config.update({
            region: 'us-east-1',
            accessKeyId: accessKeyId,
            secretAccessKey: secretAccessKey
        });
        this.ddb = new aws.DynamoDB({ apiVersion: '2012-08-10' });
    }

    sendData(data) {
        // console.log("sending data to dynamoDB: ", data)
        if (typeof (data) === "string" && data !== "undefined") {
            var params = {
                TableName: 'soundscope',
                Item: {
                    'instanceId': { S: Date.now().toString() },
                    'data': { S: data }
                }
            };

            // Call DynamoDB to add the item to the table

            this.ddb.putItem(params, function (err, data) {
                if (err) {
                    console.log("Error", err);
                } else {
                    console.log("Success", data);
                }
            });

        }
    }
}

var snapLogger = new LocalSnapLogger()//new AWSLogger()


// for this to work, ensure that the following line is in public/iSnap/logging/logger.js at line 70 : window.top.postMessage('iSnap_Log_Data:' + JSON.stringify(data), '*')
window.onmessage = function (e) {
    let message = e.data
    if (message.includes && message.includes("iSnap_Log_Data")) {
        let parts = message.split("iSnap_Log_Data:", 2)
        let dataToLog = parts[1];
        snapLogger.log(dataToLog);
        //logger.sendData(dataToSend)
    }
};

// logger.sendData({hey: "there"})

// Morphic.js Integration (Eric Stein)
// Don't think this is necessary; strings can be passed from Snap to SoundScope without Morphic.js (using snapHandler)

/*
var world;

window.onload = function () {
    console.log("HERE")
    world = new Morphic.WorldMorph(document.getElementById('world'));
    world.worldCanvas.focus();
    world.isDevMode = true;
    // loop();
};

function loop() {
    requestAnimationFrame(loop);
    world.doOneCycle();
    console.log(" a cycle has been done")
}

/* Load WebAudioFontPlayer and define functions*/

let playerConstructor = window.WebAudioFontPlayer
var player = new playerConstructor();
var AudioContextFunc = window.AudioContext || window.webkitAudioContext;
var audioContext = new AudioContextFunc();

let initialInstrumentName = "piano"
var currentInstrumentName = initialInstrumentName
let instrumentVolumes = {};

var currentInstrument = null;
var currentEnvelope = null;
var currentVolume = 0.5 // 0 to 1, change to change player volume

/**
 * Preloads instruments so that there is no delay when users attempt to play instruments for the first time
 * @param instrumentData
 */
const preloadInstruments = async (instrumentData) => {
    let keys = Object.keys(instrumentData);
    const results = [];
    for (var i = 0; i < keys.length; i++) {
        let currName = keys[i];
        console.log("preloading " + currName);
        results.push(instrumentNameToValue(currName)); // handles loading; TODO: refactor so that both functions use a separate loading function for increased modularity
    }
    await Promise.allSettled(results);
}
// preloadInstruments(instrumentData)

/**
 * Used to determine the appropriate WebAudioFontPlayer instrument from a name
 * @param instrumentName
 * @since 2020.5.21
 * Written by Eric Stein, comment by Eric Stein
 */
function instrumentNameToValue(instrumentName) {
    return new Promise((resolve, reject) => {
        let selectedInstrumentData = instrumentData[instrumentName.toLowerCase()]
        if (selectedInstrumentData) {
            let path = selectedInstrumentData.path;
            let name = selectedInstrumentData.name;
            if (path && name) {
                player.loader.startLoad(audioContext, path, name);
                console.log("waiting for load")
                player.loader.waitLoad(function () {
                    console.log("finished loading")
                    resolve(window[name])
                });
            } else {
                console.error("Could not find instrument data for instrument with name " + instrumentName)
                reject();
            }
        } else {
            // try to find in custom instruments
            selectedInstrumentData = customInstrumentData[instrumentName.toLowerCase()];
            if (selectedInstrumentData) {
                resolve(selectedInstrumentData);
            } else {
                console.error("Could not find instrument data for instrument with name " + instrumentName)
                reject()
            }
        }
    })
}

/** Used to change the current WebAudioFontPlayer instrument; returns a promise
 * Written by Eric Stein, comment by Eric Stein
 * @since 2020.1.26
 */
function changeInstrument(instrumentName) {
    return new Promise((resolve, reject) => {
        instrumentNameToValue(instrumentName).then((val) => {
            console.log("changing to ", val);
            currentInstrument = val;
            currentInstrumentName = instrumentName;
            currentSnapiFrame && currentSnapiFrame.setProjectVariable("currentInstrument", currentInstrumentName);
            resolve();
        }).catch((e) => {
            reject(e);
        })
    })
}
window.changeInstrument = changeInstrument;

changeInstrument(initialInstrumentName).then(() => {
    console.log("changed instrument to initial instrument: ", initialInstrumentName);
    activateMicrophoneStreaming();
})

/**
 * Sets the volume of the specified instrument to the specified volume
 * Written by Eric Stein, comment by Eric Stein
 * @param instrumentName
 * @param volumePercent
 * @returns {Promise<any>}
 * @since 2020.6.2
 */
function setVolumeOfInstrument(instrumentName, volumePercent) {
    return new Promise((resolve, reject) => {
        instrumentVolumes[instrumentName] = volumePercent / 100;
        resolve();
    })
}

/** Used to play a note using WebAudioFontPlayer and the current instrument; returns a promise
 * Written by Eric Stein, comment by Eric Stein
 * @since 2020.1.26
 */
let lastSoundID = -1;
const playNote = (note, duration, instrumentName, volume) => {
    return new Promise((resolve, reject) => {
        // Get Appropriate Instrument
        var instrumentData = currentInstrument;
        new Promise((resolveInstrument, rejectInstrument) => {
            if (instrumentName) {
                instrumentNameToValue(instrumentName).then((val) => { // loads instrument
                    instrumentData = val;
                    resolveInstrument();
                })
            } else {
                instrumentName = currentInstrumentName
                resolveInstrument();
            }
        }).then(() => {
            instrumentName = instrumentName.toLowerCase();
            let durationDouble = parseFloat(duration)
            if (!Number.isNaN(durationDouble)) {

                // convert the given note to its sharped enharmonic
                // and extract the midi pitch and frequencies
                // in the event of a rest, we skip everything and resolve()
                note = convertToSharp(note);

                let rest = (note === "r" || note === "R");

                // only proceeds with playing a note if the midi note is not a rest
                if (!rest) {

                    //converts note to midi pitches and frequency
                    let midiPitch = midiPitches[note]
                    let midiFreq = midiFreqs[note]

                    if (midiPitch) {
                        // determine volume
                        let selectedVolume = null;
                        if (instrumentVolumes[instrumentName]) { // from set volume of instrument
                            console.log("found instrument volume")
                            selectedVolume = instrumentVolumes[instrumentName];
                        } else if (volume != null) {
                            let volumeInt = parseInt(volume);
                            if (volumeInt != null) {
                                selectedVolume = volumeInt / 100
                            }
                        }
                        // currentEnvelope && currentEnvelope.cancel()
                        // actually play sound
                        console.log(instrumentData);
                        currentEnvelope = player.queueWaveTable(audioContext, audioContext.destination, instrumentData, 0.1, midiPitch, durationDouble, selectedVolume); // actives microphone streaming
                        // send to midi communicator
                        midiCommunicator && midiCommunicator.onPlayNote(midiFreq, durationDouble)
                        // display sound
                        let currentSoundID = currentSnapiFrame.addSound({ gain: selectedVolume, freq: midiFreq })
                        lastSoundID = currentSoundID;

                        // set currently playing note variable
                        currentSnapiFrame && currentSnapiFrame.setProjectVariable("Changed Note?", true);

                        //set current note variable
                        currentSnapiFrame && currentSnapiFrame.setProjectVariable("Current Note", note);
                        currentSnapiFrame && currentSnapiFrame.setProjectVariable("Current Note MIDI", midiPitch);

                        // remove sound when time is up
                        setTimeout(() => {
                            if (currentSnapiFrame) {
                                currentSnapiFrame.removeSound({ ID: currentSoundID })
                            }
                            if (lastSoundID === currentSoundID) { // the last note to be played has finished playing
                                currentSnapiFrame && currentSnapiFrame.setProjectVariable("Changed Note?", false);
                            }
                        }, durationDouble * 1000)
                        // resolve because we successfully played a note
                        resolve()
                    } else {
                        console.error("Could not find MIDI value for note " + note)
                        reject()
                    }
                } else {
                    // resolve because we rested
                    resolve()
                }
            } else {
                console.error("Provided duration could not be parsed into a double")
                reject()
            }
        })
    })
}
window.playNote = playNote; // set as global function

const stopPlayingNotes = () => {
    player.cancelQueue(audioContext);
}
window.stopPlayingNotes = stopPlayingNotes; // set as global function

/**
 * @deprecated
 */
const playList = async (list) => {
    if (!list.contents) return; // TODO: print error
    if (list.contents.length !== 2) return; // TODO: print error
    const notes = list.contents[0].contents;
    const durations = list.contents[1].contents;

    for (let i = 0; i < notes.length; i++) {
        const note = notes[i];
        if (i > durations.length - 1) return; // TODO: print error
        const durationInSeconds = durations[i];
        await playNote(note, durationInSeconds)
        await wait(durationInSeconds * 1000)
    }
}
window.playList = playList;


const playTrackMeasure = async (currTrack, measureIndex, beatsPerMeasure, tempo, instrument, playTrackExecution) => {
    var beat = 0;
    const beatEndIndex = beatsPerMeasure[0];
 
    while (beat < beatEndIndex) {
        const note = currTrack[measureIndex][0];
        const noteLength = currTrack[measureIndex][1];
        measureIndex++; //increment for the next index in the track

        const durationInSeconds = noteLength * (baseTempo / tempo);

        // stop if cancelled
        if (playTrackExecution.cancelled) {
            break;
        }

        // play the note and wait
        await playNote(note, durationInSeconds, instrument)
        await wait(durationInSeconds * 1000)

        // we increment i with respect to the number of beats the current note occupies in a measure
        beat += noteLength * beatsPerMeasure[1];
    }

}

// stores metadata for each call of Play Tracks; useful for cancelling play track executions
class PlayTrackExecution {
    cancelled = false;
    callbackVar;

    constructor(callbackVar) {
        this.callbackVar = callbackVar;
    }

    cancel = () => {
        this.cancelled = true
        if (this.callbackVar) {
            currentSnapiFrame.setProjectVariable(this.callbackVar, "DONE"); // stop waiting on Snap! side
            setTimeout(() => {
                currentSnapiFrame.deleteProjectVariable(this.callbackVar); // force delete (just in case Snap! errored)
            }, 1000)
        }
    }
}

const currentPlayTrackExecutions = {};
const playTracks = async (tracksList, timeSignature, tempo, callbackVar) => {
    //clear console for testing
    console.clear()
    // verify inputs
    if (!tracksList.contents) return;

    const beatsPerMeasure = timeSignatureToBeatsPerMeasure[timeSignature];

    // create and track PlayTrackExecution
    const startTime = new Date().getTime();
    const playTrackExecution = new PlayTrackExecution(callbackVar);
    currentPlayTrackExecutions[startTime] = playTrackExecution;

    /* No longer need to do this because of List -> Array conversion method */
    // create a deep copy of the tracksList variable to avoid changing the
    // actual variable value in the Snap! iframe
    //var tracks = JSON.parse(JSON.stringify(tracksList)).contents

    var tracks = convertListToArrayRecursive(tracksList);

    // convert all elements in the track to lowercase
    tracks = util.toLowerCaseRecursive(tracks);

    // check to make sure we have an actual melody/chord track rather than just a loop
    // this ensures that we have a definitive track length
    let haveSetTrackLength = false
    let definitiveTrackIndex = 0 //index of valid melody/chord track

    // check to make sure we have an actual melody/chord track rather than just a loop
    // this ensures that we have a deinitive track length
    for (let i = 0; i < tracks.length; i++) {
        let currTrack = tracks[i];
        if (currTrack[0][0] === "melody" || currTrack[0][0] === "chords") {
            definitiveTrackIndex = i;
            haveSetTrackLength = true;
            break;
        }
    }


    if (!haveSetTrackLength) {
        console.error("No Melody or Chord track provided, only Chord/Drum Loop")
        return;
    }

    /*
        first, add up all the note values in the track
        to determine the total number of beats
        then, calculate the number of measures by considering the time signature
        and the total number of beats in the track list
    */

    // converts the strings of note length in each track to their respective duration values
    for (let i = 0; i < tracks.length; i++) {
        let currTrack = tracks[i];
        for (let j = 1; j < currTrack.length; j++) { //index from 1 to avoid the header
            //Reassign the durations list to numerical duration values from strings
            //jth (Note, Duration) pair
            currTrack[j][1] = noteLengthToTimeValue[currTrack[j][1]]
        }
    }

    // properly encodes drum tracks
    for (let i = 0; i < tracks.length; i++) {
        let currTrack = tracks[i];
        // check each track's header to see whether it is a drum track
        // Header: (Instrument, Type)
        if (currTrack[0][0] === "loop-drums") {
            var isBassDrum = (currTrack[0][1] === "bass drum");
            for (let j = 1; j < currTrack.length; j++) {
                if (currTrack[j][0] === "x") { // ("x", duration) encode a note
                    //check if the instrument is a bass drum
                    if (isBassDrum) {
                        currTrack[j][0] = "C2";
                    } else {
                        currTrack[j][0] = "C4";
                    }
                } else { //(" ", duration) encode a rest
                    currTrack[j][0] = "R";
                }

                //converting the duration length to the appropriate value based on the timesignature
                // If eighth notes get the beat, subdivide drum tracks into sixteenth notes
                if (beatsPerMeasure[1] == 0.5) {
                    currTrack[j][1] = 0.25;
                }
            }
        }
    }

    // calculates the total number of beats in the song
    var totalBeats = 0;
    var defTrack = tracks[definitiveTrackIndex];
    for (let j = 1; j < defTrack.length; j++) {
        totalBeats += parseFloat(defTrack[j][1]);
    }

    // length of measure = total number of beats (w.r.t which note gets the beat) / beats per measure
    const totalMeasures = (totalBeats) / (beatsPerMeasure[0] * beatsPerMeasure[1]);

    //convert any melody/chord/drum loop to a regular track
    // done by repeatedly appending the array to itself
    for (let i = 0; i < tracks.length; i++) {
        let currTrack = tracks[i];
        //check if the current track is a loop
        if (currTrack[0][0] === "loop-melody" || currTrack[0][0] === "loop-chords" || currTrack[0][0] === "loop-drums") {
            let beatsInLoop = 0;
            for (let j = 1; j < currTrack.length; j++) {
                beatsInLoop += parseFloat(currTrack[j][1]);
            }
            let loopCount = parseInt(totalBeats / beatsInLoop);

            //appending the track to itself
            //we don't repeat the header
            let header = currTrack[0];
            let newTrack = util.multiplyArray(currTrack.slice(1), loopCount);
            newTrack.unshift(header)

            if (header[0] === "loop-chords") {
                newTrack[0][0] = "chords";
            } else {
                newTrack[0][0] = "melody";
            }

            //push the multiplied track to the tracks list
            //and remove the original loop
            tracks.push(newTrack)
            tracks.splice(i,1)
            i--;
        }
    }


    for (let i = 0; i < tracks.length; i++) {
        let currTrack = tracks[i];
        //find which elements of the track list are embedded chords
        if (currTrack[0][0] === "chords") {
            let chordInstrument = currTrack[0][1];
            let maxChordLen = 0;
            for (let j = 1; j < currTrack.length; j++) {
                // iterate through each chord in the track to find the largest chord (most # of notes)
                maxChordLen = Math.max(maxChordLen, currTrack[j][0].length);
            }
            
            //splits the notes of chords into separate tracks
            for(let k = 0; k < maxChordLen; k++) {
                // the new track will have the same instrument, but be encoded as a melody line
                let newTrack = [["melody", chordInstrument]];
                for (let j = 1; j < currTrack.length; j++) {
                    let currChord = currTrack[j][0];
                    // if the chord is large enough, add the kth note of the chord to the melody line
                    //otherwise, the melody will rest for that note in the track
                    if (k < currChord.length) {
                        // kth note of the chord, keep the duration of the chord
                        newTrack.push([currChord[k], currTrack[j][1]]);
                    }else {
                        newTrack.push(["r", currTrack[j][1]]);

                    }
                }
                //add this new track to the overarching tracklist
                tracks.push(newTrack);
            }
            // delete original chord track from tracks
            tracks.splice(i, 1);
            i--;
        }
    }


    // Play Measures track by track
    for (let i = 0; i < totalMeasures; i++) {
        console.log("Playing measure " + (i + 1));
        const measureResults = [];

        // count for the number of beats that have passed since the last measure
        // e.g. in 4/4, measure 3 will have 2*4 = 8 beats elapsed. Next measure starts
        // on beat 8 (0 indexed)
        let elapsedBeats = i * beatsPerMeasure[0];

        //per track
        for (let j = 0; j < tracks.length; j++) {
            let currTrack = tracks[j];
            let instrument = currTrack[0][1];
            let measureIndex = 0;
            let elapsedSum = 0;

            // identifying where in the track array to begin the measure
            // since different tracks have different array lengths, but
            // the same amount of beats, they will align at each measure
            // beat-wise, but have different starting indices measure-wise
            for (let k = 1; k < currTrack.length; k++) {
                if (elapsedSum >= elapsedBeats) {
                    measureIndex = k;
                    break;
                } else {
                    // add the value of the kth duration
                    elapsedSum += parseFloat(currTrack[k][1]);
                }
            }

            measureResults.push(new Promise((resolve, reject) => {
                playTrackMeasure(currTrack, measureIndex, beatsPerMeasure, tempo, instrument, playTrackExecution).then(() => {
                    resolve();
                }).catch((err) => {
                    reject(err);
                })
            }));
        }
        await Promise.all(measureResults);
    }


    
    // remove PlayTrackExecution from object
    delete currentPlayTrackExecutions[startTime];

    if (callbackVar) {
        currentSnapiFrame.setProjectVariable(callbackVar, "DONE"); // stop waiting on Snap! side
        setTimeout(() => {
            currentSnapiFrame.deleteProjectVariable(callbackVar); // force delete (just in case Snap! errored)
        }, 1000)
    }
}
window.playTracks = (tracksList, timeSignature, tempo, callbackVar) => {
    playTracks(tracksList, timeSignature, tempo, callbackVar).then(() => {

    }).catch((err) => {
        console.log("error in playTracks:", err)
        if (callbackVar) {
            currentSnapiFrame.setProjectVariable(callbackVar, "DONE"); // stop waiting on Snap! side
            setTimeout(() => {
                currentSnapiFrame.deleteProjectVariable(callbackVar); // force delete (just in case Snap! errored)
            }, 1000)
        }
    })
}



/**
 * Plays midi note from midi controller
 * Written by Harsh Padhye, comment by Harsh Padhye
 * @since 10/7/2020
 */


const controller_default = "MPK mini 3"; //MPK mini 3 //MPK Mini Mk II

var midi_note_stream = [];
var current_controller = controller_default;
var current_tempo = baseTempo; //base 60 bpm
var midi_instrument = null;
var milli_to_beat = {};

const playMidiController = async (controller_name, instrument) => {
    //ensures that we don't pass an empty value to the webmidi.enable()
    if (controller_name !== null || controller_name !== "") {
        current_controller = controller_name;
    }
    if (instrument != null) {
        midi_instrument = instrument;
    }
    //enables the webmidi controller, doesn't record notes
    WebMidi.enable((err) => {
        if (err) {
            alert(err);
        } else {
            onEnabled();
        }
    });
}


const recordMidiController = async (controller_name, tempo, instrument) => {
    //ensures that we don't pass an empty value to the webmidi.enable()
    if (controller_name !== null && controller_name !== "") {
        current_controller = controller_name;
    }
    //sets the tempo at which to record the midi notes
    if (tempo != null && tempo != 0) {
        current_tempo = tempo;
    }
    if (instrument != null) {
        midi_instrument = instrument;
    }

    //populates the millisecond to beat value conversion dictionary
    milli_to_beat = convertBeatsToMilliseconds(tempo);

    //enables the webmidi controller and records all inputs
    midi_note_stream = []; //resets note array
    WebMidi.enable((err) => {
        if (err) {
            alert(err);
        } else {
            onRecord();
        }
    });
}

const stopMidiController = async (out_var) => {
    //enables the webmidi controller
    WebMidi.disable();
    if (midi_note_stream.length != 0) {
        let notes_out = out_var + " Notes";

        const midi_note_list = convertArrayToListRecursive(midi_note_stream);

        //send output vars to snap
        currentSnapiFrame && currentSnapiFrame.setProjectVariable(notes_out, midi_note_list);
    }
}

window.playMidiController = playMidiController;
window.recordMidiController = recordMidiController;
window.stopMidiController = stopMidiController;

/**
 * Activates listeners for the midi controller
 */

function onEnabled() {
    let synth = WebMidi.getInputByName(current_controller);
    let keyboard = synth.channels[1];

    // Listener for the keyboard, prints midi note number
    keyboard.addListener("noteon", e => {
        playNote(e.note.identifier, 0.5, midi_instrument);
    });
}

function onRecord() {
    let synth = WebMidi.getInputByName(current_controller);
    if (!synth) return;
    let keyboard = synth.channels[1];
    var time_queue = new util.Queue();
    // Listener for the keyboard, pushes note to variable list
    keyboard.addListener("noteon", e => {
        //push the timestamp to the queue
        //this is the time in ms of when the key is pressed
        time_queue.enqueue(e.timestamp)
        playNote(e.note.identifier, 0.5, midi_instrument);
    });

    keyboard.addListener("noteoff", e => {
        let end_time = e.timestamp;
        var elapsed_time = Math.abs(end_time - time_queue.dequeue());
        var beat_value = quantizeNote(elapsed_time);

        midi_note_stream.push([e.note.identifier, beat_value]);
    });
}

//helper fucntions for midi recording
function convertBeatsToMilliseconds(tempo) {
    //sets the millisecond value for 1 beat
    let one_beat = 60000 / tempo;
    //maps milliseconds -> note name
    let d = {};
    for (const [key, value] of Object.entries(noteLengthToTimeValue)) {
        // ex: for 120 bpm, we might have a key,value pair {250, "Eighth"}
        d[Math.round(one_beat * value)] = key;
    }
    return d;
}

//takes the note length in milliseconds and quantizes
//it to the nearest beat value w.r.t. tempo
function quantizeNote(elapsed) {
    var closest = Number.MAX_SAFE_INTEGER;
    // iterates through the millisecond values
    for (const key of Object.keys(milli_to_beat)) {
        if (Math.abs(key - elapsed) < Math.abs(closest - elapsed)) {
            closest = key; //this is a millisecond value
        }
    }

    return milli_to_beat[closest]; //note length value ("Quarter", "Half", "Eighth", etc.)
}

/**
 * Activates microphone streaming (a window.postMessage is required)
 * Written by Eric Stein, comment by Eric Stein
 * @since 4/27/2020
 */
let activateMicrophoneStreaming = () => {
    window.postMessage("test");
    playNote("C4", 1, null, 0).catch((err) => {
        console.log("error caught: ", err)
    })
}

/* Snap! Integration */

window.id = "soundscope";

window.addEventListener("message", snapHandler, false);

function stripOuterQuotationMarks(s) {
    /** Removes outer quotation marks from a string, if any exist
     * Written by Eric Stein, comment by Eric Stein
     * @since 2020.1.22
     */
    if (s !== undefined && s !== null && typeof (s) === "string") {
        if (s.charAt(0) === '"' || s.charAt(0) === "'") {
            s = s.substring(1, s.length - 1)
        }
        if (s.charAt(s.length - 1) === '"' || s.charAt(s.length - 1) === "'") {
            s = s.substring(0, s.length - 2)
        }
    }

    return s
}

function nullifyIfNeeded(arg) {
    /** Used to send a null value instead of an undefined value; not used
     * Written by Eric Stein, comment by Eric Stein
     * @since 2020.1.22
     */
    return arg === undefined ? null : arg
}

function prepareArg(arg) {
    /** Prepares an arg to be used in tone.js commands
     * Written by Eric Stein, comment by Eric Stein
     * @since 2020.1.22
     */
    return stripOuterQuotationMarks(arg)
}

function addQuotationsToArgs(functionAndArgsString) {
    console.log(functionAndArgsString);
    let parts = functionAndArgsString.split("(")
    let args = parts[1].split(")")[0]
    console.log(args)
    // remove spaces
    for (var i = 0; i < args.length; i++) {
        if (args.charAt(i) === ' ') {
            args = args.substring(0, i) + args.substring(i + 1)
        }
    }
    args = args.split(",")
    var argsString = ""
    for (var i = 0; i < args.length; i++) {
        args[i] = '"' + args[i] + '"'
        if (i < args.length - 1) {
            args[i] += ","
        }
        argsString += args[i]
    }

    return parts[0] + "(" + argsString + ")"
}

function extractArgs(commandWithArgs) {
    let splitByOpeningParenthesis = commandWithArgs.split("(")
    if (splitByOpeningParenthesis[0]) {
        var restOfCommand = "";
        for (var i = 1; i < splitByOpeningParenthesis.length; i++) {
            restOfCommand += splitByOpeningParenthesis[i];
            if (i < splitByOpeningParenthesis.length) {
                restOfCommand += "(";
            }
        }
        restOfCommand = restOfCommand.substring(0, restOfCommand.length - 2);
        return restOfCommand.split(",")
    }
    return null
}

/**
 * splits by ~**~ instead of ,
 */
const extractArgsSafe = (commandWithArgs) => {
    let splitByOpeningParenthesis = commandWithArgs.split("(")
    if (splitByOpeningParenthesis[0]) {
        var restOfCommand = "";
        for (var i = 1; i < splitByOpeningParenthesis.length; i++) {
            restOfCommand += splitByOpeningParenthesis[i];
            if (i < splitByOpeningParenthesis.length) {
                restOfCommand += "(";
            }
        }
        restOfCommand = restOfCommand.substring(0, restOfCommand.length - 2);
        return restOfCommand.split("~**~")
    }
    return null
}

let convertArrayToListRecursive = (array) => {
    if (Array.isArray(array)) {
        for (var i = 0; i < array.length; i++) {
            array[i] = convertArrayToListRecursive(array[i]);
        }
        return currentSnapiFrame.snapIde.newList(array);
    }
    return array;
}

let convertListToArrayRecursive = (list) => {
    let temp = []
    // need to do more testing for chords and nested lists
    if (!(list.contents === undefined)) {
        for (var i = 0; i < list.contents.length; i++) {
            temp[i] = convertListToArrayRecursive(list.contents[i]);
        }
        return temp;
    } else {
        return list;
    }
}

let copyTest = (list) => {
    console.log(list)
    let arr = convertListToArrayRecursive(list);
    console.log(arr)
    console.log(arr[0])
    console.log(arr[0][1]);
}
window.copyTest = copyTest;


let importMusicXML = (xmlString) => {
    return new Promise((resolve, reject) => {
        // convert from MusicXML String to tuneScopeString
        let tuneScopeCSV = musicXMLAgent.convertMusicXMLStringToTuneScopeCSV(xmlString);
        console.log(tuneScopeCSV);

        // download to local pc
        // musicXMLAgent.downloadCSV(tuneScopeCSV);

        // send variable to Snap!
        let messageToSnap = convertArrayToListRecursive(tuneScopeCSV);
        console.log("messageToSnap", messageToSnap)
        currentSnapiFrame && currentSnapiFrame.setProjectVariable("Current Song", messageToSnap);
        resolve();
    })
}


//David
let importABC = (abcString) => {
    return new Promise((resolve, reject) => {
        // convert from ABC String to tuneScopeString
        let tuneScopeCSV = musicXMLAgent.convertABCStringToTuneScopeCSV(abcString);
        console.log(tuneScopeCSV);
        // send variable to Snap!
        let messageToSnap = convertArrayToListRecursive(tuneScopeCSV);
        console.log("messageToSnap", messageToSnap)
        currentSnapiFrame && currentSnapiFrame.setProjectVariable("Current Song", messageToSnap);
        resolve();
    })
}

//David
let abcSongSearch = (searchString) => {
    return new Promise((resolve, reject) => {
        //get song's abc string from search
        //using first result for now
        songSearch.getABCSearchResult(searchString).then((abcString) => {
            //let abcString = songSearch.getABCSearchResult(searchString);
            //convert abc string to
            //let tuneScopeCSV = importABC(abcString);
            //let tuneScopeCSV = musicXMLAgent.convertABCStringToTuneScopeCSV(abcString);
            //console.log(tuneScopeCSV);
            // send variable to Snap!
            //let messageToSnap = convertArrayToListRecursive(tuneScopeCSV);
            let messageToSnap = abcString;
            console.log("messageToSnap", messageToSnap)
            currentSnapiFrame && currentSnapiFrame.setProjectVariable("ABC Searched Song", messageToSnap);
            resolve();
        })


    })
}


let exportToMusicXML = (tuneScopeString) => {
    return new Promise((resolve, reject) => {
        // convert from tuneScopeString to MusicXML
        let musicXMLString = musicXMLAgent.convertTuneScopeStringToMusicXMLString(tuneScopeString);
        // download?

        resolve();
    })
}

function interpretSnapMessage(message) {
    /** Extracts the message from a signal received from Snap! and performs the appropriate function
     * Written by Eric Stein, comment by Eric Stein
     * @since 2020.1.14
     * @updated 2020.1.22
     */

    if (message && message.includes && !message.includes("iSnap_Log_Data") && !(message === "test")) {
        if (message.includes("window.location")) {
            let args = message.split("~");
            let windowLocationValue = JSON.parse(args[1]);
            console.log(windowLocationValue);
            return;
        }

        var args = message.split(".")
        if (args.length > 1 && args[0] === "synth") { // using object.method(args) syntax (not currently used)
            let objectName = args[0]
            var object
            switch (args[0]) {
                case "synth":
                    object = "(new Tone.MembraneSynth().toMaster())";
                    break
            }
            let stringCommand = object + "." + addQuotationsToArgs(args[1])
            console.log("Performing command " + stringCommand)
            eval(stringCommand);
        } else { // using custom syntax
            // let commandWithProperStrings = addQuotationsToArgs(args[0])
            args = [message];
            let commandName = args[0].split("(")[0]
            let commandArgs = extractArgs(args[0])

            // get time sent (if any)
            if (commandArgs.length > 0) {
                const lastCommandArg = commandArgs[commandArgs.length - 1];
                const splitByTime = lastCommandArg.split("TIME=");
                if (splitByTime.length > 1) {
                    commandArgs.splice(commandArgs.length - 1, 1); // remove from args
                    const timeSent = Number.parseInt(splitByTime[1]);
                    console.log("Message Delivery Time: " + ((new Date().getTime() - timeSent) / 1000));
                }
            }
            switch (commandName) {
                case "importMusicXML":
                    importMusicXML(commandArgs[0]).catch((err) => {
                        console.log("Error importing Music XML file: " + err);
                    })
                    break;
                case "setInstrument":
                    let currentInstrumentName = commandArgs[0].toLowerCase()
                    changeInstrument(currentInstrumentName).catch((err) => {
                        console.log("error caught: ", err)
                    })
                    break;
                case "playSound":
                    let note = commandArgs[0];
                    let instrument = commandArgs[1];
                    let duration = commandArgs[2];
                    let volume = commandArgs[3];

                    const startTime = new Date().getTime();
                    playNote(note, instrument, duration, volume).catch((err) => {
                        console.log("error caught: ", err)
                    }).then(() => {
                        const timeElapsed = new Date().getTime() - startTime;
                        console.log(`Note Playback Time: ${timeElapsed / 1000} seconds`);
                    })
                    break;
                case "setVolumePercent":
                    let selectedVolumePercent = parseInt(commandArgs[0]);
                    currentVolume = selectedVolumePercent / 100;
                    break;
                case "setVolumeOfInstrument":
                    let selectedInstrument = commandArgs[0].toLowerCase();
                    let selectedVolumePercentForInstrument = parseInt(commandArgs[1]);
                    setVolumeOfInstrument(selectedInstrument, selectedVolumePercentForInstrument).catch((err) => {
                        console.log("Error setting volume of instrument " + selectedInstrument + " to " + selectedVolumePercentForInstrument + "%: " + err);
                    })
                    break;
                case "setScopeVisibility":
                    let newScopeValue = commandArgs[0];
                    if (newScopeValue === "0" || newScopeValue === "false") {
                        currentSnapiFrame && currentSnapiFrame.expand();
                    } else if (newScopeValue === "true") {
                        currentSnapiFrame && currentSnapiFrame.shrink();
                    }
                    break;
                case "modifyOscillator":
                    let number = parseInt(commandArgs[0]) - 1;
                    const frequency = parseInt(commandArgs[1]);
                    const amplitude = parseFloat(commandArgs[2]) * 100; // later gets divided down

                    if (number === -1) {
                        break;
                    }

                    // if number >= new id, create a new one
                    if (number >= newId) {
                        number = newId;
                        createAnOscillator();
                    }

                    // find oscillator
                    const oscParentEl = document.getElementById('oscillators');
                    const oscillators = oscParentEl.childNodes;
                    let oscillator;

                    for (var i = 0; i < oscillators.length; i++) {
                        const currOscillator = oscillators[i];
                        if (currOscillator.getAttribute) {
                            const currNumber = parseInt(currOscillator.getAttribute("data-id"));
                            if (currNumber === number) {
                                oscillator = currOscillator;
                                break;
                            }
                        }
                    }

                    if (oscillator) {
                        const player = oscillator.player;

                        // modify frequency
                        const freqBox = player.freqBox;
                        const freqSlider = player.freqSlider;

                        freqBox.setAttribute('value', frequency)

                        //const freqEvent = new Event('input', {});
                        //freqBox.dispatchEvent(freqEvent);
                        setFreq(frequency, player, freqSlider, freqBox);

                        // modify amplitude
                        const volumeBox = player.volumeBox;
                        const volumeSlider = player.volumeSlider;

                        volumeBox.setAttribute('value', amplitude);

                        //const amplitudeEvent = new Event('input', {});
                        //volumeBox.dispatchEvent(amplitudeEvent);
                        setVol(amplitude, player, volumeSlider, volumeBox);

                    }

                    toggleOscillator(number, "true");

                    break;
                case "toggleOscillator":
                    const oscNumber = parseInt(commandArgs[0]) - 1;
                    const newOn = commandArgs[1];

                    toggleOscillator(oscNumber, newOn);

                    break;
                case "setFreeze":
                    let newFreezeValue = commandArgs[0];
                    if (newFreezeValue === "0" || newFreezeValue === "false") {
                        thawDisplay();
                    } else if (newFreezeValue === "true") {
                        freezeDisplay();
                    }
                    break;
                case "updateTuneScopeURL":
                    if (commandArgs[0]) {
                        const snapURL = args[0].split("(")[1].split(")")[0];
                        if (snapURL && snapURL.includes("Username")) {
                            console.log(snapURL);
                            if (currentSnapiFrame) {
                                setTimeout(function () {
                                    currentSnapiFrame.loadSnapProject(snapURL);
                                }, 3000);
                            }
                        }
                    }
                    break;
                case "textGuide": { // id, title, body
                    const guideBlockArgs = extractArgsSafe(args[0]);
                    if (guideBlockArgs.length !== 3) return;

                    const id = guideBlockArgs[0];
                    const type = "text";
                    const title = guideBlockArgs[1];
                    const value = guideBlockArgs[2];

                    const guideFrame = guideFrameFactory.getGuideFrame(id);

                    guideFrame.setData({
                        type: type,
                        title: title,
                        value: value
                    });
                    guideFrame.show();

                    break;
                }
                case "videoGuide":
                    const guideBlockArgs = extractArgsSafe(args[0]);
                    if (guideBlockArgs.length !== 3) return;

                    const id = guideBlockArgs[0];
                    const type = "video";
                    const title = guideBlockArgs[1];
                    const value = guideBlockArgs[2];

                    const guideFrame = guideFrameFactory.getGuideFrame(id);

                    guideFrame.setData({
                        type: type,
                        title: title,
                        value: value
                    });
                    guideFrame.show();

                    break;
                case "positionGuideFrame": { // id, leftPercent, topPercent
                    const guideBlockArgs = extractArgsSafe(args[0]);
                    if (guideBlockArgs.length !== 3) return;

                    const id = guideBlockArgs[0];
                    const leftPercent = guideBlockArgs[1];
                    const topPercent = guideBlockArgs[2];

                    const guideFrame = guideFrameFactory.getGuideFrame(id);

                    guideFrame.moveTo(leftPercent, topPercent);
                    guideFrame.show();

                    break;
                }
                case "showGuideFrame": { // id
                    const guideBlockArgs = extractArgsSafe(args[0]);
                    if (guideBlockArgs.length !== 1) return;

                    const id = guideBlockArgs[0];

                    const guideFrame = guideFrameFactory.getGuideFrame(id);

                    guideFrame.show();

                    break;
                }
                case "hideGuideFrame": { // id
                    const guideBlockArgs = extractArgsSafe(args[0]);
                    if (guideBlockArgs.length !== 1) return;

                    const id = guideBlockArgs[0];

                    const guideFrame = guideFrameFactory.getGuideFrame(id);

                    guideFrame.hide();

                    break;
                }
                case "copyToClipboard": { // string
                    const clipboardArgs = extractArgsSafe(args[0]);
                    if (clipboardArgs.length !== 1) return;

                    const string = clipboardArgs[0];

                    // copy to clipBoard

                    navigator.clipboard.writeText(string).then(function () {
                        console.log("Copied to clipboard: " + string);
                    }, function () {
                        console.log("Error copying to clipboard");
                    });

                    break;
                }
                case "plotPointOnScope": { // x, y
                    const plotArgs = extractArgsSafe(args[0]);
                    if (plotArgs.length !== 2) return;
                    console.log(plotArgs);

                    const x = parseFloat(plotArgs[0]);
                    const y = parseFloat(plotArgs[1]);

                    plotPointOnScope(x, y);

                    break;
                }
                case "plotPointsOnScope": { // points
                    const clipboardArgs = extractArgsSafe(args[0]);
                    if (clipboardArgs.length !== 1) return;

                    const points = clipboardArgs[0];

                    console.log(points);
                    // TODO: parse into array (e.g. [[0,0],[0,1], ...])
                    const pointsArray = [];
                    for (var i = 0; i < pointsArray; i++) {
                        plotPointOnScope(pointsArray[i][0], pointsArray[i][1]);
                    }


                    break;
                }
                case "clearScope": {
                    clearScope();
                    break;
                }
                case "copyScopeToSnap": {
                    sendDataPointsToSnap(dots);
                    break;
                }
                case "startSnapRecording": {
                    if (!snapLogger) return;
                    if (!currentSnapiFrame || currentSnapiFrame.mode !== "isnap") return;
                    snapLogger.resetRecording();
                    snapLogger.startRecording();
                    break;
                }
                case "saveSnapRecording": {
                    // legacy snapLogger method
                    if (snapLogger && currentSnapiFrame && currentSnapiFrame.mode === "isnap") {
                        snapLogger.saveRecordingToJSON();
                        snapLogger.resetRecording();
                    }

                    // new method
                    //const state = currentSnapiFrame.getScriptState();
                    //console.log(state);

                    break;
                }
                case "importABC": {
                    const importABCArgs = extractArgsSafe(args[0])[0];
                    importABC(importABCArgs).catch((err) => {
                        console.log("Error importing ABC file: " + err);
                    })
                    break;
                }
                case "abcAI": {
                    const abcAIArgs = extractArgsSafe(args[0]);
                    if (abcAIArgs.length !== 2) return;
                    const abcString = abcAIArgs[0];
                    const numberToGenerate = abcAIArgs[1];
                    AbcAIAgent.getPrediction(abcString, numberToGenerate).then((result) => {
                        currentSnapiFrame && currentSnapiFrame.setProjectVariable("ABC AI Output", result);
                    }).catch((err) => {
                        console.log("Error getting prediction using AbcAIAgent: " + err);
                    })
                    break;
                }
                case "runPlaybackScript": {
                    const runPlaybackScriptArgs = extractArgsSafe(args[0]);
                    if (runPlaybackScriptArgs.length !== 1) return;
                    const playbackScript = runPlaybackScriptArgs[0];
                    currentSnapiFrame.buildBlocksFromScript(playbackScript);
                    break;
                }
                case "pausePlaybackScript": {
                    currentSnapiFrame && currentSnapiFrame.pausePlaybackScript();
                    break;
                }
                case "resumePlaybackScript": {
                    currentSnapiFrame && currentSnapiFrame.resumePlaybackScript();
                    break;
                }
                case "stopPlaybackScript": {
                    currentSnapiFrame && currentSnapiFrame.stopPlaybackScript();
                    break;
                }
                case "fastFourierTransform": {

                    break;
                }
                case "searchABC": {
                    const searchABCArgs = extractArgsSafe(args[0])[0];
                    currentSnapiFrame && currentSnapiFrame.setProjectVariable("ABC Searched Song", "Loading...");
                    abcSongSearch(searchABCArgs).catch((err) => {
                        console.log("Error searching ABC Song: " + err);
                        currentSnapiFrame && currentSnapiFrame.setProjectVariable("ABC Searched Song", "Could not find ABC song");
                    })
                    break;
                }
                case "getHint": {
                    if (!currentSnapiFrame) return;
                    const state = currentSnapiFrame.getScriptState();
                    console.log(state);

                    function getBlockParam(block) {
                        if (block.blockSpec == "turn %clockwise %n degrees" | block.blockSpec == "turn %counterclockwise %n degrees") {
                            return parseInt(block.children[2].children[0].text);
                        }
                        return parseInt(block.children[1].children[0].text);
                    }
                    function generateCurSequence(block) {
                        let newSequence = [];
                        for (let i = 0; i < block.children.length; i++) {
                            if (block.children[i].blockSpec == "repeat %n %loop") {
                                newSequence.push(["Repeat", getBlockParam(block.children[i])]);
                                let nextPiece = generateCurSequence(block.children[i].children[2]);
                                for (let j = 0; j < nextPiece.length; j++) {
                                    newSequence.push(nextPiece[j]);
                                }
                                newSequence.push("EndRepeat");
                                nextPiece = generateCurSequence(block.children[i]);
                                for (let j = 0; j < nextPiece.length; j++) {
                                    newSequence.push(nextPiece[j]);
                                }
                            } else if (block.children[i].blockSpec == "move %n steps") {
                                newSequence.push(["Move", getBlockParam(block.children[i])]);
                                let nextPiece = generateCurSequence(block.children[i]);
                                for (let j = 0; j < nextPiece.length; j++) {
                                    newSequence.push(nextPiece[j]);
                                }
                            } else if (block.children[i].blockSpec == "turn %clockwise %n degrees") {
                                newSequence.push(["Turn_clockwise", getBlockParam(block.children[i])]);
                                let nextPiece = generateCurSequence(block.children[i]);
                                for (let j = 0; j < nextPiece.length; j++) {
                                    newSequence.push(nextPiece[j]);
                                }
                            } else if (block.children[i].blockSpec == "turn %counterclockwise %n degrees") {
                                newSequence.push(["Turn_counterclockwise", getBlockParam(block.children[i])]);
                                let nextPiece = generateCurSequence(block.children[i]);
                                for (let j = 0; j < nextPiece.length; j++) {
                                    newSequence.push(nextPiece[j]);
                                }
                            }
                        }
                        return newSequence;
                    }

                    const hintScript = "";
                    function trim(s) {
                        if (typeof (s) != "string") {
                            return "Something went wrong, please try again";
                        }
                        return s.replaceAll("(", '').replace(")", "").replaceAll("'", "");
                    }
                    async function retrieveHint(curState) {
                        const qValsRef = db.collection('qVals');
                        const snapshot = await qValsRef.where('State', '==', curState).get();
                        var hint = "";
                        if (snapshot.empty) {
                            console.log('No matching documents.');
                            return hint;
                        }
                        // hint data array then filter then return hint
                        var bestQ = -100000;
                        snapshot.forEach(doc => {
                            console.log(doc.id, '=>', doc.data());
                            if (doc.data().qval > bestQ) {
                                bestQ = doc.data().qval;
                                hint = doc.data().Action;
                            }
                        });
                        const hintPieces = hint.split(",");
                        const hintText = trim(hintPieces[0]);
                        var hintParams = trim(hintPieces[1]);
                        if (hintPieces.length == 3) {
                            hintParams = [trim(hintPieces[1]), trim(hintPieces[2])];
                            return [hintText, hintParams];
                        }
                        return [hintText, hintParams];
                    };

                    var stateArray = generateCurSequence(state);
                    var stateString = "[";
                    for (var i = 0; i < stateArray.length; i++) {
                        if (stateArray[i] == "EndRepeat") {
                            stateString += "'EndRepeat'";
                        } else {
                            if (stateArray[i][0] == "Move") {
                                if (stateArray[i][1] > 0) {
                                    stateString = stateString + "('" + stateArray[i][0] + "', " + 1 + ")";
                                } else {
                                    stateString = stateString + "('" + stateArray[i][0] + "', " + stateArray[i][1] + ")";
                                }
                            } else {
                                stateString = stateString + "('" + stateArray[i][0] + "', " + stateArray[i][1] + ")";
                            }
                        }
                        if (i != (stateArray.length - 1)) {
                            stateString += ", "
                        }
                    }
                    stateString += "]"
                    async function displayHint(s, arr) {
                        var response = await retrieveHint(s);
                        const id = 1234;
                        var pos = -1000;
                        var newVal = -1000;
                        if (response[1] === undefined) {
                            const guideFrame = guideFrameFactory.getGuideFrame(id);
                            guideFrame.setData({
                                type: "text",
                                title: "Hint for making a square",
                                value: "We could not find any hints for you right now. Please change something and try again."
                            });
                            guideFrame.show();
                            return;
                        } else if (typeof (response[1]) == "string") {
                            pos = arr[parseInt(response[1])];
                        } else if (response[1].length == 2) {
                            pos = arr[parseInt(response[1][0])];
                            newVal = parseInt(response[1][1]) + 1;
                        }

                        const guideFrame = guideFrameFactory.getGuideFrame(id);

                        var hintText = "";

                        if (response[0] == "change param") {
                            newVal -= 1;
                            hintText = "Change paramteter at block (" + pos + ")";
                            if (newVal !== -1000) {
                                hintText = hintText + " to " + newVal;
                            }
                        } else if (response[0] == "add block") {
                            hintText = "Add a new" + response[1][1] + " block after (" + pos + ")";
                        } else if (response[0] == "move block") {
                            hintText = "Move block (" + pos + ") to be block number " + newVal;
                        } else if (response[0] == "delete block") {
                            hintText = "Delete block (" + pos + ")";
                        }


                        guideFrame.setData({
                            type: "text",
                            title: "Hint for making a square",
                            value: hintText
                        });
                        guideFrame.show();
                    }

                    displayHint(stateString, stateArray);

                    currentSnapiFrame.buildBlocksFromScript(hintScript);
                    break;
                }
            }
        }
    }
}

/**
 *
 * @param expression
 * @param currScript
 */
const blockExpressionToPlaybackScript = (expression) => {
    // verify that this expression is of a block
    const blockSpec = expression.blockSpec;
    if (!blockSpec) return "";

    // build script entry
    // 1) add block name
    let scriptAddition = "";
    scriptAddition += blockSpec;
    // 2) build arg sequence
    let argSequence = "[";
    for (let i = 0; i < expression.children.length; i++) {
        const currChild = expression.children[i];
        if (currChild.cachedInputs !== undefined) { // is InputSlotMorph
            if (currChild.children.length > 0) {
                const stringMorphChild = currChild.children[0]
                const arg = stringMorphChild.text;
                argSequence += arg + " ";
            }
        }
    }
    argSequence += "]";
    scriptAddition += argSequence;
    let script = scriptAddition + "\n"

    // recurse to next block child
    const numChildren = expression.children.length;
    if (numChildren === 0) {
        return script;
    }
    script += blockExpressionToPlaybackScript(expression.children[expression.children.length - 1]);
    return script;
};

/**
 * Called when a user places ringified blocks as input into the GenerateBlocks block
 * @param blocksData
 */
const generateBlocks = (blocksData) => {
    console.log(blocksData);
    if (!currentSnapiFrame) return;
    const expression = blocksData.expression;
    if (!expression) return;
    const playbackScript = blockExpressionToPlaybackScript(expression);
    console.log(playbackScript)
    currentSnapiFrame.buildBlocksFromScript(playbackScript);
}
window.generateBlocks = generateBlocks;

const toggleOscillator = (oscNumber, newOn) => {
    // find oscillator
    const oscParent = document.getElementById('oscillators');
    const oscillatorsList = oscParent.childNodes;
    let selectedOscillator;

    for (var i = 0; i < oscillatorsList.length; i++) {
        const currOscillator = oscillatorsList[i];
        if (currOscillator.getAttribute) {
            const currNumber = parseInt(currOscillator.getAttribute("data-id"));
            if (currNumber === oscNumber) {
                selectedOscillator = currOscillator;
                break;
            }
        }
    }

    if (selectedOscillator) {
        const selectedPlayer = selectedOscillator.player;
        const onoffBtn = selectedPlayer.onoffBtn;

        if (newOn === "true") {
            if (!selectedPlayer.playing) {
                onoffBtn.classList.toggle('switch');
                toggleSound(selectedPlayer);
            }
        } else {
            if (selectedPlayer.playing) {
                onoffBtn.classList.toggle('switch');
                toggleSound(selectedPlayer);
            }
        }
    }
}

const customPlot = [];
const plotPointOnScope = (x, y) => {
    const selectedAudioInputValue = audioInputSourceSelect.options[audioInputSourceSelect.selectedIndex].value
    if (selectedAudioInputValue !== "Plotting") {
        // TODO: switch mode automatically?
    }

    const transformedX = (x * 10) - 2//9.7775;

    const transformedY = 122.5 - (100 * y);

    // TEST: ctx2.lineTo(xc, Math.random() * 1200 - 600); i.e. if (plotting) set lineTo y=plot[xc] something // TODO: plotting
    // xc:
    // yc0 = 1, yc225=-1

    selectAudioInputSource("Plotting");
    customPlot.push([transformedX, transformedY]);


}

function snapHandler(event) {
    /** A function that listens to events from a Snap iFrame.
     * Written by Rich Nguyen and Eric Stein, comment by Eric Stein
     * @since 2020.1.14
     */

    event.preventDefault();
    //console.log("Message received from Snap at ", new Date().getTime());
    interpretSnapMessage(event.data);
    return;
}

let currentSnapiFrame = null // created or removed when the current source is changed (in selectMode)
const modeToSnapiFrame = {};

window.loadHash = (hash) => {
    console.log("LOADED HASH: ", hash);
}

/** A class that is used to create/remove a Snap project in an iFrame that can communicate with SoundScope
 * Written by Eric Stein, comment by Eric Stein
 * @since 2020.1.14
 */
class snapiFrame {
    snapURLSynchronizer;
    blockBuilder;

    expanded;
    currentSounds = {};
    currentSoundID = 0;

    visibleClassname = "Snap-Frame-Visible";
    expandedClassname = "Snap-Frame-Expanded";
    invisibleClassname = "Snap-Frame-Invisible";

    iFrameClassname = "Snap-iFrame";

    urlContainerClassname = "Snap-URL";
    urlLabelClassname = "Snap-URL-Label";
    urlInputClassname = "Snap-URL-Input";
    urlButtonClassname = "Snap-URL-Button";

    constructor(mode, parent) {

        //David TODO
        //Wakes the cors anywhere heroku app, a proxy server for abc song search result scrap
        var ImageObject = new Image();
        ImageObject.src = "https://tunescope.herokuapp.com/";
        if (ImageObject.height > 0) {
            console.log("Ping worked!");
        } else {
            console.log("Ping failed :(");
        }

        window.currentSnapiFrame = this;

        if (mode === undefined) {
            mode = snapMode
        }
        this.snapURLSynchronizer = new SnapURLSynchronizer(this);
        this.blockBuilder = new BlockBuilder(this);

        this.expanded = false
        this.parent = parent;

        // create container
        this.container = document.createElement("div");

        // create URL text input
        this.urlInputContainer = document.createElement("div")
        this.urlInputContainer.className = this.urlContainerClassname;

        this.urlInputLabel = document.createElement("label")
        this.urlInputLabel.className = this.urlLabelClassname;
        this.urlInputLabel.innerHTML = "Project URL: ";

        this.urlInput = document.createElement("input")
        this.urlInput.className = this.urlInputClassname

        this.urlInputButton = document.createElement("button")
        this.urlInputButton.className = this.urlButtonClassname;
        this.urlInputButton.innerHTML = "Go";
        this.urlInputButton.onclick = this.onUrlButtonClick;

        this.urlInputContainer.appendChild(this.urlInputLabel);
        this.urlInputContainer.appendChild(this.urlInput);
        this.urlInputContainer.appendChild(this.urlInputButton);

        // create iframe

        this.iframe = document.createElement("iframe");
        this.iframe.className = this.iFrameClassname
        //this.iframe = document.createElement("div");
        // TODO: make snap frame start with editor
        // ./Snap/snap.html
        var src
        console.log("snapMode: " + mode)
        switch (mode) {
            case "isnap":
                src = "./iSnap/snap.html#open:/" + SnapProjectName
                break;
            case "snap4arduino":
                src = "./Snap4Arduino/index.html#open:/" + SnapProjectName// "./Snap4Arduino/snap.html#open:/" + SnapProjectName
                break;
            default:
                src = "./Snap/snap.html#open:/" + SnapProjectName
                break;
        }
        this.mode = mode;
        // this.iframe.innerHTML='<object type="text/html" data=' + src + '></object>';
        this.iframe.setAttribute("src", src); // #open:TuneScope.xml

        //this.iframe.setAttribute("src", "//snap.berkeley.edu/snap/snap.html#present:Username=ericstein&ProjectName=SoundScope&editMode");
        //parent.insertBefore(this.iframe, this.parent.childNodes[0]);
        //oscParentEl.appendChild(this.iframe)

        // Call with initial URL
        this.snapURLSynchronizer.onTuneScopeURLChanged(window.location.href);

        // MORPHIC

        this.iframe.onload = () => {

            try {
                this.snapWorld = this.iframe.contentWindow.world
                this.snapIde = this.snapWorld.children[0];

                console.log(this.snapIde)
                this.onInitialSnapLoad();
            } catch (err) {
                console.log("Error after loading Snap! iFrame: ", err);
            }
            /*
            setInterval(() => {
              this.snapIde.setVar("test", true);
            }, 1000)
            */
            //console.log(this.snapIde)
            /*
            this.snapIde.addMessageListenerForAll((msg) => {
              console.log("new snap iframe sent a message: ", msg)
            });
            */

        }

        // Combine everything

        //this.container.append(this.urlInputContainer)
        this.container.append(this.iframe)

        this.parent.append(this.container)

        this.expand() // remove to make snapiFrame start as not expanded
        this.show()


        /*
        setInterval(() => {
            console.log(this.iframe.contentDocument)
        }, 1000)

         */
    }

    onInitialSnapLoad = () => {
        // Listen for project loads
        this.snapIde.listenForLocalUserProjectOpen(this.onSnapProjectLoaded)
        this.snapIde.listenForNewProject(this.onNewProject);
        this.snapIde.listenForStopButtonClicked(this.onStopButtonClicked)
        this.setFlatTheme()
    }

    onStopButtonClicked = () => {
        // cancel all tracks
        Object.values(currentPlayTrackExecutions).forEach((playTrackExecution) => {
            playTrackExecution.cancel();
        })

        // stop playing all currently playing notes
        stopPlayingNotes()
        //window._ts_pausePlayback = true;
    }

    setProjectVariable = (variableName, value) => {
        if (!this.snapIde) return;

        console.log("Setting project variable " + variableName + " to ", value);

        //this.snapIde.setOrCreateVar(variableName, value)

        //this.snapIde && this.snapIde.setVar(variableName, value);
    }


    deleteProjectVariable = (variableName) => {
        if (!this.snapIde) return;

        this.snapIde.deleteVar(variableName);
    }

    onUrlButtonClick = () => {
        let input = this.urlInput.value
        this.loadSnapProject(input).then(() => {

        }).catch((err) => {
            this.urlInput.value = err;
        })
    }

    onSnapProjectLoaded = (projectName, username) => {
        this.snapURLSynchronizer.onSnapProjectLoaded(projectName, username);
    }

    onNewProject = () => {
        this.snapURLSynchronizer.onNewProject()
    }

    /**
     * loads a snap project given a Snap! project url
     * @param url
     */
    loadSnapProject = (url) => {
        return new Promise((resolve, reject) => {

            setTimeout(function () {
                currentSnapiFrame.expand();
            }, 100);
            if (url.includes("snap.html")) {
                this.snapURLSynchronizer.parseTuneScopeURL(url).then((response) => {
                    const { username, projectName } = response;
                    setTimeout( () => {
                        this.snapIde.loadPublicProject(username, projectName).then(resolve).catch(reject);
                    }, 3000);
                }).catch((err) => {
                    reject("Failed to parse Snap! project: " + err)
                })

                /*
                if (this.iframe.getAttribute("src") !== url) {
                    let newSrc = url
                    this.iframe.setAttribute("src", newSrc);
                    this.snapURLSynchronizer.onSnapProjectLoaded(url);
                    //window.location.search = "?snapProject=" + encodeURIComponent(newSrc);
                    resolve();
                } else {
                    reject("Requested Snap! project already loaded")
                }
                 */
            } else {
                reject("Invalid URL")
            }
        })
    }

    hide = () => {
        this.container.className = this.invisibleClassname
    }

    show = () => {
        if (this.expanded) {
            if (menuCollapsed) {
                this.container.className = "Snap-Frame-Expanded-Menu-Collap";
            } else {
                this.container.className = this.expandedClassname;
            }
        } else {
            this.container.className = this.visibleClassname
        }
    }

    updateGraph = () => {
        //refreshCanvas()
        drawData()
        //animate()
    }

    addSound = (config) => {
        let { gain, freq } = config
        let soundData = {
            gain: gain,
            freq: freq
        }
        let ID = this.currentSoundID;
        this.currentSoundID++
        this.currentSounds[ID] = soundData
        this.updateGraph()
        return ID;
    }

    removeSoundID = (ID) => {
        this.currentSounds[ID] = null
        this.updateGraph()
    }

    removeSound = (config) => {
        if (config.ID !== null && config.ID !== undefined) {
            this.removeSoundID(config.ID)
        } else {
            let ID = null
            let values = Object.values(this.currentSounds)
            for (var i = 0; i < values.length; i++) {
                let currentSoundData = values[i]
                if (currentSoundData.gain == config.gain && currentSoundData.freq == config.freq) {
                    ID = Object.keys(this.currentSounds)[i]
                    break
                }
            }
            if (ID !== null) {
                this.removeSoundID(ID)
            }
        }
    }

    getSounds = () => {

        return Object.values(this.currentSounds)
    }

    remove = () => {
        this.container.remove()
        currentSnapiFrame = null
    }

    expand = () => {
        this.expanded = true;
        this.parent.setAttribute('data-expanded', 'true');
        if (menuCollapsed) {
            this.container.className = "Snap-Frame-Expanded-Menu-Collap";
        } else {
            this.container.className = this.expandedClassname;
        }
        //this.container.className = this.expandedClassname;
        freezeDisplay();
    }

    shrink = () => {
        this.expanded = false;
        this.parent.setAttribute('data-expanded', 'false');
        this.container.className = this.visibleClassname
        thawDisplay();
    }

    buildBlocksFromScript = (script) => {
        this.blockBuilder.runScript(script).then(() => {
            console.log("Successfully ran blockBuilder script");
        }).catch((err) => {
            console.log("Error building blocks from script: ", err);
        })
    }

    pausePlaybackScript = () => {
        try {
            this.blockBuilder.pause();
        } catch (err) {
            console.log("Error pausing playback script: ", err.toString())
        }
    }

    resumePlaybackScript = () => {
        this.blockBuilder.resume().then(() => {

        }).catch((err) => {
            console.log("Error resuming playback script: ", err.toString())
        });
    }

    stopPlaybackScript = () => {
        try {
            this.blockBuilder.stop();
        } catch (err) {
            console.log("Error stopping playback script: ", err.toString())
        }
    }

    newBlock = (options) => {
        return this.snapIde.newBlock(options);
    }

    setInput = (options) => {
        this.snapIde.setInput(options);
    }

    snapBlocks = (options) => {
        this.snapIde.snapBlocks(options);
    }

    insertBlockIntoBlock = (options) => {
        this.snapIde.insertBlockIntoBlock(options);
    }

    deleteBlock = (options) => {
        this.snapIde.deleteBlock(options);
    }
    setFlatTheme = () => {
        this.snapIde.setSnapFlat();
    }
    setDarkTheme = () => {
        this.snapIde.setSnapDark();
    }


    executeBlock = (options) => {
        this.snapIde.executeBlock(options);
    }

    getScriptState = () => {
        return this.snapIde.getScriptState();
    }
}

class ResizeSnapButton {
    button;
    expandedText;
    minimizedText;
    defaultText;

    constructor() {
        this.expandedText = "Scope";
        this.minimizedText = "Scope";
        this.defaultText = this.expandedText;

        this.button = this.build()
        document.getElementById("selectDiv").appendChild(this.button)
    }

    build = () => {
        let resizeSnapButton = document.createElement('button');
        resizeSnapButton.classList.add("toggle-btn", "freeze-btn", "resize-snap-btn", "collapItm");
        resizeSnapButton.setAttribute("name", "resize-snap-button")
        resizeSnapButton.setAttribute('data-expanded', 'true');
        resizeSnapButton.setAttribute("data-hidden", "false")
        resizeSnapButton.appendChild(document.createElement('span'));
        resizeSnapButton.innerHTML = this.defaultText;
        resizeSnapButton.addEventListener("click", (event) => {
            event.preventDefault();
            if (currentSnapiFrame) {
                if (currentSnapiFrame.expanded) {
                    resizeSnapButton.setAttribute("data-expanded", "false")
                    resizeSnapButton.innerHTML = this.minimizedText;
                    currentSnapiFrame.shrink();
                } else {
                    resizeSnapButton.setAttribute("data-expanded", "true")
                    resizeSnapButton.innerHTML = this.expandedText;
                    currentSnapiFrame.expand();
                }
            }
        }, false);
        return resizeSnapButton;
    }

    show = () => {
        this.button.setAttribute("data-hidden", "false");
        this.button.style.visibility = "visible";
        this.button.classList.remove("resize-snap-btn-invisible");
        this.button.classList.add("toggle-btn", "freeze-btn", "resize-snap-btn", "collapItm");
    }

    hide = () => {
        this.button.setAttribute("data-hidden", "true");
        this.button.style.visibility = "hidden";
        this.button.classList.add("resize-snap-btn-invisible");
    }
}

let currentResizeSnapButton = new ResizeSnapButton();
currentResizeSnapButton.hide();

// Collapsible content for live edit!
var coll = document.getElementsByClassName("collapsible");
var i;

for (i = 0; i < coll.length; i++) {
    coll[i].addEventListener("click", function () {
        this.classList.toggle("active");
        var content = this.nextElementSibling;
        if (content.style.display === "block") {
            content.style.display = "none";
        } else {
            content.style.display = "block";
        }
    });
}

/*
var LiveEditor = require('/live-editor')
 var liveEditor = new LiveEditor({
        editorType: "ace_webpage",
        outputType: "webpage",
        el: $("#sample-live-editor"),
        code: window.localStorage["test-webpage-code"] ||
            "<!DOCTYPE html>\n<strong>Hello</strong>, world!",
        width: 400,
        height: 400,
        editorHeight: "80%",
        autoFocus: true,
        workersDir: "/src/build/workers/",
        externalsDir: "/src/build/external/",
        imagesDir: "/src/build/images/",
        execFile: "output_webpage.html"
    });
    liveEditor.editor.on("change", function() {
        window.localStorage["test-webpage-code"] = liveEditor.editor.text();
    });
*/

var mediaRecorder = null;
var audio = null;
var introJsOsc = introJs();
introJsOsc.setOption("showBullets", true);
introJsOsc.setOption("exitOnOverlayClick", false);
var tutorialMode = false;
// end recordAudio const

//Unused variable
var AudioContext = (window.AudioContext || window.webkitAudioContext || window.mozAudioContext || window.oAudioContext || window.msAudioContext);

var streaming = false;
var newId = 0;
var tutorialStep = 1;
let onBtn2 = null; //Unused
let fs1 = null; //Unused, check first before deleting
// define tooltips for each data point
var dots = [];
var audioContext = new AudioContext();
var gainNode = audioContext.createGain();
var analyser = audioContext.createAnalyser();
gainNode.gain.value = 3;
analyser.smoothingTimeConstant = .9;
try {
    analyser.fftSize = 1024 * 16; // potentially should be less to have higher canvas response
} catch (e) {
    analyser.fftSize = 2048;
}
gainNode.connect(analyser);
// frequencyBinCount is readonly and set to fftSize/2;
var timeDomain = new Uint8Array(analyser.frequencyBinCount);
var streaming = false;
var sampleRate = audioContext.sampleRate;
var numSamples = analyser.frequencyBinCount;

const audioInputSelect = document.querySelector('select#audioSource');
const audioInputSourceSelect = document.querySelector('select#audioInput');
const selectors = [audioInputSelect, audioInputSourceSelect];

navigator.mediaDevices.enumerateDevices().then((deviceInfos) => {
    gotDevices(deviceInfos)
}).catch(handleError);

var mode = document.getElementById("audioSource");
mode.addEventListener('change', (function (event) {
    event.preventDefault();
    var modeId = mode.selectedIndex;
    var whichMode = mode.options[modeId].value;
    selectMode(whichMode);
    enableMic()
}), false);
setTimeout(() => {
    defaultScreenName !== "" && selectMode(defaultScreenName);
}, 100)

var currFreq = 1000

createAnOscillator();
//document.getElementById('addanother').style.visibility = 'hidden';

var ui = {
    inputType: {
        title: "Input",
        value: 2,
        values: [["Live Input (5 V peak amplitude)", 1], ["Sine Wave (amplitude 5 V)", 2], ["Square Wave (amplitude 5 V)", 3]]
    },
    freeze: {
        title: "Freeze Live Input",
        value: false,
    },
    freq: {
        title: "Frequency",
        value: 440,
        range: [1, 2048],
        resolution: 1,
        units: "Hz"
    },
    gain: {
        title: "Amplitude",
        value: 1,
        range: [0, 5],
        resolution: 0.1,
    },
    dropdownExample: { // time domain
        title: "Seconds / div",
        value: 10,//600,//60,
        //10,
        values: [["50 µs", 0.05], ["100 µs", 0.1], ["200 µs", 0.2], ["500 µs", 0.5], ["1 ms", 1], ["2 ms", 2], ["5 ms", 5], ["10 ms", 10]]
        //[["50 µs", 0.05], ["100 µs", 0.1], ["200 µs", 0.2], ["500 µs", 0.5], ["1 ms", 1], ["2 ms", 2], ["5 ms", 5],["10 ms",10]]
    },
    volts: {
        title: "Volts / div",
        value: 1,
        values: [["1 V", 0.2], ["2 V", 0.4], ["5 V", 1], ["10 V", 2]]
    },
    horizOffset: {
        title: "Horizontal Offset",
        value: 0,
        range: [-100, 100],
        resolution: 1,
        input: "hidden"
    },
    vertOffset: {
        title: "Vertical Offset",
        value: 0,
        range: [-100, 100],
        resolution: 1,
        input: "hidden"
    }
};

/*------------------------------------------------------------------------------------
                                CREATE CANVASES
/*----------------------------------------------------------------------------------*/
var demo = document.getElementById('demo'); // PREVENT SCROLLING
var c = document.createElement("canvas"); // for gridlines
c.id = "gridLines";

var c2 = document.createElement("canvas"); // for animated line
c2.id = "animatedLines";

var tipCanvas = document.createElement("canvas"); // for tooltips
tipCanvas.id = "tip";
var w = window;

//$("#demo").height(document.getElementById('graph').clientHeight*0.85);


c.width = demo.clientWidth;
//c.height = 250;
c.height = document.getElementById('demo').clientHeight;

c2.width = demo.clientWidth;
c2.height = c.height;
//$("#demo").height(c.height + 20);
c.style.backgroundColor = "#fefefe";

demo.appendChild(c);
demo.appendChild(c2);
demo.appendChild(tipCanvas);

var midPoint = { x: 0, y: c.height / 2 };

var ctx = c.getContext("2d");
ctx.textAlign = 'center';
ctx.textBaseline = "alphabetic";
ctx.font = "1.2em Franklin Gothic Medium";
ctx.fillStyle = "#000";
var ctx2 = c2.getContext("2d");
var tipCtx = tipCanvas.getContext("2d");
tipCtx.font = "1.2em Franklin Gothic Medium";
tipCtx.fillStyle = '#E57200';

window.addEventListener("resize", refreshCanvas);

var mapRange = function (from, to, s) {
    return to[0] + (s - from[0]) * (to[1] - to[0]) / (from[1] - from[0]);
};

var mapRangeInv = function (from, to, s) {
    return from[0] + (s - to[1]) * (from[1] - from[0]) / (to[1] - to[0]);
}

var animateId;
var previousTranslate = { x: 0, y: 0 };

createGrid(ctx);


var canvasOffset = $("#demo").offset();
var offsetX = canvasOffset.left;
var offsetY = canvasOffset.top;

$("#demo").mousemove(handleMouseMove);

// Create save csv button

/*
let saveBtn = document.createElement('button');
saveBtn.id = "saveBtn";
saveBtn.classList.add("general-btn", "save-btn");

saveBtn.innerHTML = "EXPORT";
saveBtn.addEventListener("click", (function (event) {
    event.preventDefault();
    saveDataPoints(dots);
}), false);
 */

// Create copy to snap button

const copyToSnapButton = document.createElement("button");
copyToSnapButton.style.display = "none"; // if we want it back, delete this line
copyToSnapButton.id = "copyToSnapButton";
copyToSnapButton.innerHTML = "COPY TO SNAP";
copyToSnapButton.addEventListener("click", function (event) {
    event.preventDefault();
    sendDataPointsToSnap(dots);
})
copyToSnapButton.classList.add("general-btn", "save-btn"); // copyToSnapButton

let selectDiv = document.getElementById('demo');
//selectDiv.appendChild(saveBtn);
selectDiv.appendChild(copyToSnapButton);

createUiVertOffset();
giveTutorial();
addIntroData();
//startTutorial();
//addFilterPanel();

document.getElementById('addanother').addEventListener("click", (function (event) {
    event.preventDefault();
    createAnOscillator();

    if (tutorialMode == true) {
        introJsOsc.addSteps([
            {
                element: document.getElementsByClassName("toggle1")[0],
                intro: "Click ON to turn the second oscillator on.",
                position: 'right'
            },
            {
                element: document.getElementsByClassName("mute1")[0],
                intro: "<img src='https://cdn-prod.medicalnewstoday.com/content/images/articles/322/322868/golden-retriever-puppy.jpg' width='200px'/><b>If you like, you can also click the MUTE button to mute the sound.</b>",
                position: 'right'
            },
            {
                element: document.getElementsByClassName("fs1")[0],
                intro: "Set the second oscillator to 400 Hz.",
                position: 'bottom-left'
            },
            {
                element: document.getElementById('demo'),
                intro: "<h3>Combined Wave</h3>A single cycle of the combined waveform looks like this. A complete cycle still takes the same amount of time (one-hundredth of a second). However, the waveform is no longer a pure tone. Combining the 200 Hz tone with a 400 Hz tone results in a complex waveform. A complex waveform consists of two or more frequencies mixed together. Addition of the 400 Hz tone results in a double peak in a single cycle – one large peak and a second smaller one."
            },
            {
                element: document.getElementById('demo'),
                intro: "<h3>See more Details</h3>Hover your mouse over the waveform to view its coordinates. The coordinates at the mouse cursor are displayed in (milliseconds, amplitude)."
            },
            {
                element: document.getElementById("saveBtn"),
                intro: "<h3>Export</h3>Click EXPORT to save the waveform into clipboard. Waveform is exported as a set of coordinates for further studies. Isn't SoundScope fun? click Done to exit tutorial!",
                position: 'right'
            }
        ]);

        introJsOsc.goToStepNumber(12).start();
    }



}), false);


/*------------------------------------------------------------------------------------
                                UTILITY FUNCTIONS
/*----------------------------------------------------------------------------------*/
function addIntroData() {
    /**
     * Data basic intro data for the Tutorial
     */


    introJsOsc.addSteps([
        {
            element: document.getElementById("tutorialBtn"),
            intro: "<h3>Introduction</h3>This is a demonstration of the way in which basic acoustic concepts can be introduced through SoundScope. These concepts provide the foundation for music synthesis.",
            position: 'bottom-middle-aligned'
        },
        {
            element: document.getElementById('soundscopelogo'),
            intro: "SoundScope is a tool that can be used to explore these concepts interactively.",
            position: 'bottom-middle-aligned'
        },
        {
            element: document.getElementsByClassName('toggle0')[0],
            intro: "<h3>Let's begin</h3>Begin by clicking the ON button to turn on an oscillator. This will generate a low-pitched tone.",
            position: 'right'
        },
        {
            element: document.getElementsByClassName("mute0")[0],
            intro: "<h3>Mute Button</h3>If you like, you can also click the MUTE button to mute the sound.",
            position: 'right'
        },
        {
            element: document.getElementsByClassName("freqboxwrapper0")[0],
            intro: "<h3>Sine Wave</h3>The graph of a pure tone that consists of only a single frequency produces a sine wave. In the case of a 100 Hz tone, one cycle of the waveform is completed in 10 milliseconds. Since there are 1000 milliseconds in a second, 100 cycles of the tone will be completed in one second.",
            position: 'top'
        },
        {
            //element: document.getElementById("animatedLines"),
            intro: "<h3>A Single Wave</h3>hA single cycle of the sine wave represents one back-and-forth movement. When the tone is sent to a speaker, the positive peak will move the speaker cone in one direction and the negative peak will move the cone in the opposite direction.",
            //position: 'top'
        },
        {
            element: document.getElementById('demo'),
            intro: "<h3>Number of Cycles</h3>The number of cycles can be calculated by counting the peaks. In this instance, there are ten positive peaks in one-tenth of a second. This means that there were ten complete cycles of the waveform in that time period. Since this is a 100 Hz tone, the result obtained in this way matches our expectations.",
            position: 'bottom-middle'
        },
        {
            element: document.getElementsByClassName("fs0")[0],
            intro: "<h3>Frequency</h3>Change the frequency of the tone from 100 to 200 Hz. Every tone has a frequency and an amplitude. The pitch of the tone that you hear should increase.",
            position: 'bottom-middle'
        },
        {
            element: document.getElementsByClassName("vs0")[0],
            intro: "<h3>Amplitude</h3>Change the amplitude of the tone from 0.5 V to 0.25 V. The loudness of the tone that you hear should decrease.",
            position: 'bottom-middle'
        },
        {
            element: document.getElementsByClassName("sliderWrapper")[0],
            intro: "<h3>Physical Atrributes of Sound</h3>Amplitude and frequency are the physical attributes of sound. Pitch is the perceptual correlate of frequency. Loudness is the perceptual correlate of frequency. Pitch and loudness are the way in which these attributes are perceived by the auditory system.",
            position: 'top'
        },
        {
            element: document.getElementById("addanother"),
            intro: "<h3>Combining Waves</h3>Click ADD to add a second oscillator. What do the two tones sound like when they are combined?",
            position: 'top-left'
        }

    ]);


}

function createUiVertOffset() {
    /**
     * Create a vertical offset inside canvas
     */

    let vertOffset = document.createElement('input');
    vertOffset.id = "vertOffset";

    vertOffset.classList.add("tone-slider", "vOffset");


    vertOffset.setAttribute('type', 'range');
    vertOffset.setAttribute('orient', 'vertical');


    vertOffset.setAttribute('min', 0);
    vertOffset.setAttribute('max', 200);
    vertOffset.setAttribute('value', 100);
    vertOffset.addEventListener("input", (function (event) {
        event.preventDefault();
        // implement v-offset slider here
        ui.vertOffset.value = -(parseInt(vertOffset.value) - 100);
        update(ui);
    }), false);

    let selectDiv = document.getElementById('demo');
    selectDiv.appendChild(vertOffset);
}

function giveTutorial() {
    /**
     * Gives a tutorial to Soundscope.
     *
     * Provides a step-by-step tutorial on how to use Soundscope for instructional purposes of learning soundwave and synthesis.
     *
     * @since 2019.08.31
     *
     * @listen event:click
     *
     * @param {} none.
     * @return {} none.
     */
    // Create a tutorial button
    let tutorialBtn = document.createElement('button')
    tutorialBtn.id = "tutorialBtn";
    tutorialBtn.classList.add("toggle-btn");
    tutorialBtn.innerHTML = "SHOW ME";


    tutorialBtn.addEventListener('click', () => {
        startTutorial();
    })
    // Add into preamble div
    let preambleDiv = document.getElementById('selectDiv');
    preambleDiv.appendChild(tutorialBtn);
}

function startTutorial() {
    tutorialMode = true;
    introJsOsc.onexit(function () {
        tutorialMode = false;
    });
    introJsOsc.start();
}


function refreshCanvas() {
    /** To adjust canvas to browser resize.
     * @return {void} none
     */

    let c = document.getElementById("gridLines");
    c.width = demo.clientWidth;
    var ctx = c.getContext("2d");
    ctx.canvas.width = demo.clientWidth;
    ctx.textAlign = 'center';
    ctx.textBaseline = "alphabetic";
    ctx.font = "1.2em Franklin Gothic Medium";
    ctx.fillStyle = "#000";


    let c2 = document.getElementById("animatedLines");
    c2.width = demo.clientWidth;
    var ctx2 = c2.getContext("2d");
    ctx2.canvas.width = demo.clientWidth;

    let tip = document.getElementById("tip");
    tip.width = demo.clientWidth;
    var tipCtx = tip.getContext("2d");
    tipCtx.canvas.width = demo.clientWidth;
    tipCtx.font = "1.2em Franklin Gothic Medium";
    tipCtx.fillStyle = '#E57200';


    createGrid(ctx);
    update(ui);
}

// Create freqMode switch (max 1000 hz vs 10000 hz)
let switchDiv = document.getElementById("freqMode")

function saveDataPoints(dots) {
    /**
     * Save data points into the clipboard.
     *
     * Take all the points on the canvas in 0.1 precision (ie. 21.3, 0.4) and save them into the clipboard to be pasted in a spreadsheet.
     *
     * @since 2020.8.14
     *
     * @param {dict} dots Dictionary type of points each has of a structure {x, y, ytip}.
     * @return {void} none.
     */
    //let csvContent = "Time(ms), Amplitude(V)" + "\n";
    // Add the first point (0,0)
    let csvContent = "0.0,";
    let prevTime = 0;
    let line = "";
    // For each line add the point
    dots.forEach(function (infoArray, index) {
        // Save only points that greater than previous point
        if (parseFloat(x2time(infoArray.x)) > prevTime) {
            line = y2amplitude(infoArray.yTip) + ",";
            csvContent += line;
            prevTime = x2time(infoArray.x);
        }
    });
    // copyStringToClipboard
    downloadCSVString(csvContent);
    //copyStringToClipboard(csvContent);
}

/**
 * Sends dots to Snap!
 * @param dots - List<Dot>, where Dot has the fields x, y, and ytip
 */
const sendDataPointsToSnap = (dots) => {
    try {
        const dotsArray = [];
        for (var i = 0; i < dots.length; i++) {
            dotsArray.push(y2amplitude(dots[i].yTip));
        }
        const snapList = convertArrayToListRecursive(dotsArray);
        currentSnapiFrame && currentSnapiFrame.setProjectVariable("Scope Capture", snapList);
    } catch (err) {
        console.log("Error exporting ScopeCapture to Snap!: ", err);
    }
}

const downloadCSVString = (csvString) => {
    // create properly formatted csv string
    const csvContent = "data:text/csv;charset=utf-8,"
        + csvString;

    var encodedUri = encodeURI(csvContent);

    // name the file
    var link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", "ScopeCapture.csv");
    document.body.appendChild(link); // Required for FF

    // download
    link.click();
}

function copyStringToClipboard(str) {
    /**
     * Copies string to clipboard and creates a temporary notification in top right of screen
     * Writen by Rich Nguyen
     * Written by Rich Nguyen, comment by Alex Li
     * @since 2019.12.16
     *
     * @param {string} str String type that will be copied to clipboard
     * @return {void} none
     */
    // Create new element
    var el = document.createElement('textarea');
    // Set value (string to be copied)
    el.value = str;
    // Set non-editable to avoid focus and move outside of view
    el.setAttribute('readonly', '');
    el.style = { position: 'absolute', left: '-9999px' };
    document.body.appendChild(el);
    // Select text inside element
    el.select();
    // Copy text to clipboard
    document.execCommand('copy');
    // Remove temporary element
    document.body.removeChild(el);
    // Notify the user
    window.createNotification({
        // close on click
        closeOnClick: true,

        // displays close button
        displayCloseButton: false,

        // nfc-top-left
        // nfc-bottom-right
        // nfc-bottom-left
        positionClass: 'nfc-top-right',

        // callback
        onclick: false,

        // timeout in milliseconds
        showDuration: 1500,

        // success, info, warning, error, and none
        theme: 'warning',
    })({
        message: 'Exported to Clipboard!',
    });
}



function update(el) {
    /** Updates ui based on element given
     * If element is "inputType" freeze/start animation depending on ui.inputType.value
     * ui.inputType.value = 1, mode is oscillators
     * animate() is needed for microphone/recording functionality?
     * Else, will call drawData(), animating a wave curve on the canvas
     * Written by Rich Nguyen, comment by Alex Li
     * @param {Element} el tells update function whether to cancel animation, or call drawData() or start animation
     * @return {void} none
     */
    if (el == 'inputType' && ui.inputType.value == 1) {
        streaming = true;
        //animate();
        animateId = window.requestAnimationFrame(animate);

    } else if (el == 'inputType' && ui.inputType.value != 1) {
        //cancel animation
        streaming = false;
        window.cancelAnimationFrame(animateId);
        drawData();
    } else if (streaming == true && ui.freeze.value == false) {
        //animate();
    }
    else {
        drawData();
    }
}

function enableMic() {
    streaming = true;
    //console.log("Mic/Amplifier Mode Selected!");
    if (window.stream) {
        window.stream.getTracks().forEach(track => {
            track.stop();
        });
    }
    let micPanel = document.getElementById("micPanel");
    if (!micPanel) {
        addMicPanel();
    }

    // MIC INPUT USED HERE
    const audioSource = audioInputSourceSelect.value;
    const constraints = {
        audio: { deviceId: audioSource ? { exact: audioSource } : undefined }
    };
    navigator.mediaDevices.getUserMedia(constraints).then(gotStream).then(gotDevices).catch(handleError);
    ui.inputType.value = 1;
    ui.gain.value = 1;
    ui.freeze.value = false;
}

function selectMode(whichMode) {
    /** Changes between oscillator mode, or recording mode
     * Called when dropdown menu change event is called
     * Updates ui.inputType.value to reflect changes to mode
     * @param {element} selectObj html element of a dropdown menu allowing selection of modes
     * @return {void} none
     */

    //console.log(whichMode);
    if (whichMode === "Oscillators") {
        //console.log("Oscillator Mode Selected!");
        streaming = false;
        ui.inputType.value = 2;
        removeMicPanel();

        selectAudioInputSource("Oscillators");

        enableDemo();
        showAllOscillators();
        showAddBtn();
        removeFilterPanel();
        currentSnapiFrame && currentSnapiFrame.hide()
        currentSnapiFrame = null;
        document.getElementById("oscillators-container").style.visibility = "visible"
        //currentSnapiFrame.remove()
        currentResizeSnapButton && currentResizeSnapButton.hide();

    } else if (whichMode === "Snap") {
        enableMic() // TODO; enable toggle
        // Reset previous
        //streaming = false;
        //ui.inputType.value = 2;
        removeMicPanel();
        hideAllOscillators();
        document.getElementById("oscillators-container").style.visibility = "hidden"
        hideAddBtn();
        disableDemo();

        // set correct Snap! iFrame as current, create one if it does not yet exist, and hide current Snap iFrame (if any)
        let onCorrectMode = false;
        if (currentSnapiFrame) {
            if (!(currentSnapiFrame.mode === "snap")) {
                currentSnapiFrame.hide();
            } else {
                onCorrectMode = true;
            }
        }
        if (!onCorrectMode) {
            if (!modeToSnapiFrame["snap"]) {
                modeToSnapiFrame["snap"] = new snapiFrame('snap', document.getElementById("mainBody"))
            }
            currentSnapiFrame = modeToSnapiFrame["snap"];
        }

        currentSnapiFrame.show()
        currentResizeSnapButton && currentResizeSnapButton.show();

        // Add textbox
        /*
          let filterPanel = document.getElementById("filterPanel");
          if (!filterPanel) {
            addFilterPanel();
          }

         */
    } else if (whichMode === "iSnap") {
        enableMic() // TODO; enable toggle
        // Reset previous
        //streaming = false;
        //ui.inputType.value = 2;
        removeMicPanel();
        hideAllOscillators();
        document.getElementById("oscillators-container").style.visibility = "hidden"
        hideAddBtn();
        disableDemo();
        // set correct Snap! iFrame as current, create one if it does not yet exist, and hide current Snap iFrame (if any)
        let onCorrectMode = false;

        if (currentSnapiFrame) {
            if (!(currentSnapiFrame.mode === "isnap")) {
                currentSnapiFrame.hide();
            } else {
                onCorrectMode = true;
            }
        }
        if (!onCorrectMode) {
            if (!modeToSnapiFrame["isnap"]) {
                modeToSnapiFrame["isnap"] = new snapiFrame('isnap', document.getElementById("mainBody"))
            }
            currentSnapiFrame = modeToSnapiFrame["isnap"];
        }

        currentSnapiFrame.show()
        currentResizeSnapButton && currentResizeSnapButton.show();

        // Add textbox
        /*
          let filterPanel = document.getElementById("filterPanel");
          if (!filterPanel) {
            addFilterPanel();
          }

         */
    } else if (whichMode === "Snap4Arduino") {
        enableMic() // TODO; make toggle
        // Reset previous
        streaming = false;
        ui.inputType.value = 2;
        removeMicPanel();
        hideAllOscillators();
        document.getElementById("oscillators-container").style.visibility = "hidden"
        hideAddBtn();
        disableDemo();
        // set correct Snap! iFrame as current, create one if it does not yet exist, and hide current Snap iFrame (if any)
        let onCorrectMode = false;
        if (currentSnapiFrame) {
            if (!(currentSnapiFrame.mode === "snap4arduino")) {
                currentSnapiFrame.hide();
            } else {
                onCorrectMode = true;
            }
        }
        if (!onCorrectMode) {
            if (!modeToSnapiFrame["snap4arduino"]) {
                modeToSnapiFrame["snap4arduino"] = new snapiFrame('snap4arduino', document.getElementById("mainBody"))
            }
            currentSnapiFrame = modeToSnapiFrame["snap4arduino"];
        }
        currentSnapiFrame.show()
        currentResizeSnapButton && currentResizeSnapButton.show();

        /*
        // Add textbox
        let filterPanel = document.getElementById("filterPanel");
        if (!filterPanel) {
          addFilterPanel();
        }

         */
    } else {
        enableMic()
        hideAllOscillators();
        document.getElementById("oscillators-container").style.visibility = "visible" // for recording
        hideAddBtn();
        disableDemo();
        removeFilterPanel();
        currentSnapiFrame && currentSnapiFrame.hide()
        //currentSnapiFrame.remove()
        currentResizeSnapButton && currentResizeSnapButton.hide();

    }
    update(ui);
};

function addFilterPanel() {
    let parent = document.getElementById("oscillators");
    let filterPanel = document.createElement("div");
    filterPanel.id = "filterPanel";
    filterPanel.classList.add("mic");

    let label = document.createElement('label');
    label.innerHTML = "FILTER CONTROL:";

    // Create a filter checkbox
    var chordBtn = document.createElement('button');
    // Assigning the attributes

    // to created chordBtn
    chordBtn.classList.add("toggle-btn", "freeze-btn")
    chordBtn.innerHTML = "CHORD";


    //creates 4 instances of the Tone.Synth
    var polySynth = new Tone.PolySynth(4, Tone.Synth).toMaster();

    chordBtn.addEventListener('mousedown', () => {
        //an array of notes can be passed into PolySynth
        polySynth.triggerAttackRelease(["E4", "F#4", "B4", "C#5", "D5", "F#4", "E4", "C#5", "B4", "F#4", "D5", "C#5"], "2n");
    })

    chordBtn.addEventListener('mouseup', () => {
        //unlike the other instruments, the notes need to be passed into triggerRelease
        polySynth.triggerRelease(["E4", "F#4", "B4", "C#5", "D5", "F#4", "E4", "C#5", "B4", "F#4", "D5", "C#5"])
    })

    // Create oscillator
    var oscillator = new Tone.Oscillator({
        type: "sine",
        frequency: 440,
        detune: 0,
        phase: 0,
    }).toMaster();
    // var noise = new Tone.Noise("pink").toMaster();

    var oscBtn = document.createElement('button');
    oscBtn.classList.add("toggle-btn", "freeze-btn");
    oscBtn.innerHTML = "OSC ON";
    oscBtn.setAttribute('data-play', 'false');
    oscBtn.addEventListener('click', () => {
        if (oscBtn.getAttribute('data-play') === 'false') {
            oscBtn.setAttribute('data-play', 'true');
            oscBtn.innerHTML = "OSC OFF";
            //noise.connect(oscillator);
            //noise.start();
            oscillator.start();
        } else {
            oscBtn.setAttribute('data-play', 'false');
            oscBtn.innerHTML = "OSC ON";
            oscillator.stop();
            //noise.stop();
            //noise.disconnect(oscillator);
        }
    });



    // Create a filter button
    var filterBtn = document.createElement('button')
    filterBtn.classList.add("toggle-btn");
    filterBtn.innerHTML = "FILTER";
    var filter = new Tone.Filter({
        frequency: 200,
        type: "highpass",
        rolloff: -12,
        Q: 1,
        gain: 0
    }).toMaster();



    filterBtn.addEventListener('mousedown', () => {
        oscillator.connect(filter);
        filterBtn.innerHTML = "FILTERING...";
    })

    filterBtn.addEventListener('mouseup', () => {
        oscillator.disconnect(filter);
        filterBtn.innerHTML = "FILTER";
    })



    filterPanel.appendChild(label);
    //filterPanel.appendChild(freezeBtn);
    filterPanel.appendChild(chordBtn);
    filterPanel.appendChild(oscBtn);
    filterPanel.appendChild(filterBtn);

    parent.insertBefore(filterPanel, parent.childNodes[0]);
}

const freezeDisplay = () => {
    ui.freeze.value = true;
    Array.from(document.getElementsByName("freeze-button")).forEach((el) => {
        el.setAttribute('data-frozen', 'true');
        el.innerHTML = "UNFREEZE";
    })
    update(ui);
}

const thawDisplay = () => {
    ui.freeze.value = false;
    Array.from(document.getElementsByName("freeze-button")).forEach((el) => {
        el.setAttribute('data-frozen', 'false');
        el.innerHTML = "FREEZE";
    })
    animate();
}

/**
 * Creates and returns a freeze button.
 * Written by Rich Nguyen, Comment by Eric Stein
 * @since 4/29/2020
 * @returns {HTMLButtonElement}
 */
let createFreezeButton = () => {
    let freezeBtn = document.createElement('button');
    freezeBtn.classList.add("toggle-btn", "freeze-btn", "collapItm");
    freezeBtn.setAttribute("name", "freeze-button")
    freezeBtn.setAttribute('data-frozen', 'false');
    freezeBtn.appendChild(document.createElement('span'));
    freezeBtn.innerHTML = "FREEZE";
    freezeBtn.addEventListener("click", (function (event) {
        event.preventDefault();
        if (!ui.freeze.value) {
            freezeDisplay();
        } else {
            thawDisplay();
        }
    }), false);
    return freezeBtn;
}

let topFreezeBtn = createFreezeButton()
document.getElementById("selectDiv").appendChild(topFreezeBtn)

function addMicPanel() {
    /** Create div object with a play, mute, and freeze button to control recording input modes
     * @since 2019.12.17
     * @return {void} none
     */
    let parent = document.getElementById("oscillators");
    let micPanel = document.createElement("div");
    micPanel.id = "micPanel";
    micPanel.classList.add("mic");

    let label = document.createElement('label');
    label.innerHTML = "MIC CONTROL:";

    // Create a Play button
    let playBtn = document.createElement('button');
    playBtn.classList.add("toggle-btn", "play-btn");
    playBtn.setAttribute('data-playing', 'false');
    playBtn.appendChild(document.createElement('span'));
    playBtn.disabled = true;
    playBtn.innerHTML = "PLAY";
    playBtn.addEventListener("click", (function (event) {
        event.preventDefault();

        if (playBtn.getAttribute('data-playing') === 'false') {
            (async () => {
                audio.play();
                playBtn.classList.add("Playing");
                audio.addEventListener("ended", function () {
                    playBtn.classList.remove("pause-btn", "Playing");
                    playBtn.innerHTML = "PLAY";
                    playBtn.setAttribute('data-playing', 'false');
                });
            })();
            playBtn.classList.add("pause-btn");
            playBtn.innerHTML = "PAUSE";
            playBtn.setAttribute('data-playing', 'true');
            ui.freeze.value = false;
        }
        else {
            (async () => {
                audio.pause();
            })();
            playBtn.classList.remove("pause-btn", "Playing");
            playBtn.innerHTML = "PLAY";
            playBtn.setAttribute('data-playing', 'false');
            ui.freeze.value = true;
        }

        update(ui);
    }), false);

    // Create a Record button
    let recordBtn = document.createElement('button');
    recordBtn.classList.add("toggle-btn", "record-btn", "notRec");
    recordBtn.setAttribute('data-recording', 'false');
    recordBtn.appendChild(document.createElement('span'));
    recordBtn.innerHTML = "REC";
    recordBtn.addEventListener("click", (function (event) {
        event.preventDefault();

        if (recordBtn.getAttribute('data-recording') === 'false') {
            // ui.freeze.value = false;
            recordBtn.setAttribute('data-recording', 'true');
            recordBtn.innerHTML = "STOP";
            recordBtn.classList.remove("notRec");
            recordBtn.classList.add("Rec");
            //
            navigator.mediaDevices.getUserMedia({ audio: true })
                .then(stream => {
                    mediaRecorder = new MediaRecorder(stream);
                    mediaRecorder.start();

                    const audioChunks = [];
                    mediaRecorder.addEventListener("dataavailable", event => {
                        audioChunks.push(event.data);
                    });

                    mediaRecorder.addEventListener("stop", () => {
                        const audioBlob = new Blob(audioChunks);
                        const audioUrl = URL.createObjectURL(audioBlob);
                        console.log(audioUrl)
                        audio = new Audio(audioUrl);

                    });
                });

        } else {

            audio = mediaRecorder.stop();
            playBtn.disabled = false;

            recordBtn.classList.remove("Rec");
            recordBtn.classList.add("notRec");
            recordBtn.innerHTML = "REC";
            recordBtn.setAttribute('data-recording', 'false');
            //
        };

    }), false);

    let freezeBtn = createFreezeButton()


    // Add the created buttons into the panel
    micPanel.appendChild(label);

    micPanel.appendChild(recordBtn);
    micPanel.appendChild(playBtn);
    micPanel.appendChild(freezeBtn);



    parent.insertBefore(micPanel, parent.childNodes[0]);
}

function removeFilterPanel() {
    /** Removes all the filter panels in
     * @return {void} none
     * Unused function
     * There is no element in the document with an id of "filterPanel" and no such element is created
     *
     *
     */
    let filterPanel = document.getElementById("filterPanel");
    if (filterPanel) {
        let kids = filterPanel.childNodes;
        let parent = filterPanel.parentElement;

        while (filterPanel.childNodes.length > 0) {
            filterPanel.removeChild(filterPanel.childNodes[0]);
        }

        parent.removeChild(filterPanel);
        //update(ui.gain);
    }

}

function disableDemo() {
    /** Disables the Demo button because there's no demo on the mic selection
     * Adds demo button to "freeze-btn" css class to change the button to grey
     * @return {void} none
     */
    let tutorialBtn = document.getElementById("tutorialBtn")
    tutorialBtn.classList.add("freeze-btn");
    tutorialBtn.style.display = "none";
    tutorialBtn.disabled = true;
}

function enableDemo() {
    /** Enables the Demo button
     * Removes demo button from "freeze-btn" css class to change the button back to original color
     * @since 2019.12.18
     * @return {void} none
     */
    let tutorialBtn = document.getElementById("tutorialBtn")
    tutorialBtn.classList.remove("freeze-btn");
    tutorialBtn.style.display = "initial";
    tutorialBtn.disabled = false;

}



function removeMicPanel() {
    /** Removes mic panel in the document
     * Iterates through children of mic panel and removes them
     * @since 2019.12.19
     * @return {void} none
     */
    let micPanel = document.getElementById("micPanel");
    if (micPanel) {
        let kids = micPanel.childNodes; //unused variable in this function
        let parent = micPanel.parentElement;

        while (micPanel.childNodes.length > 0) {
            micPanel.removeChild(micPanel.childNodes[0]);
        }

        parent.removeChild(micPanel);
        //update(ui.gain);
    }
}

function gotStream(stream) {
    // Create an AudioNode from the stream.
    window.mediaStreamSource = audioContext.createMediaStreamSource(stream);
    window.stream = stream;

    //for testing
    //var osc = audioContext.createOscillator();
    //osc.frequency.value = 200;
    //osc.start(0);

    // switch these lines
    window.mediaStreamSource.connect(gainNode);
    // osc.connect(gainNode);

    streaming = true;
    // $('#inputType-interface select').val(1).change();
    animate();
    // Refresh button list in case labels have become available
    return navigator.mediaDevices.enumerateDevices();

}



function hideAddBtn() {
    /** Sets visibility of addBtn to hidden
     * addBtn is html element with id = "addanother"
     * Used when switching modes, called by selectMode(selectObj)
     * Written by Rich Nguyen, comment by Alex Li
     * @since 2019.12.19
     * @return {void} none
     */
    let addBtn = document.getElementById("addanother");
    addBtn.style.visibility = "hidden";
}

function showAddBtn() {
    /** Sets visibility of addBtn to visible
     * addBtn is html element with id = "addanother"
     * Used when switching modes, called by selectMode(selectObj)
     * Written by Rich Nguyen, comment by Alex Li
     * @since 2019.12.19
     * @return {void} none
     */
    let addBtn = document.getElementById("addanother");
    addBtn.style.visibility = "visible";
}


function gotDevices(deviceInfos) {
    // Handles being called several times to update labels. Preserve values.
    const values = selectors.map(select => select.value);
    selectors.forEach(select => {
        while (select.firstChild) {
            select.removeChild(select.firstChild);
        }
    });

    // Create Snap source
    var snapOption = document.createElement('option');
    snapOption.value = "Snap";
    snapOption.text = "Snap!";
    snapOption.seltected = true;
    audioInputSelect.appendChild(snapOption);

    // Create oscillators source
    var option = document.createElement('option');
    option.value = "Oscillators";
    option.text = "Oscillators (On-board)"
    option.seltected = true; // Typo?
    audioInputSelect.appendChild(option);

    // Create iSnap source
    var iSnapOption = document.createElement('option');
    iSnapOption.value = "iSnap";
    iSnapOption.text = "iSnap!";
    iSnapOption.seltected = true;
    // audioInputSelect.appendChild(iSnapOption);

    // Create Snap4Arduino source
    var snap4ArduinoOption = document.createElement('option');
    snap4ArduinoOption.value = "Snap4Arduino";
    snap4ArduinoOption.text = "Snap4Arduino"
    snap4ArduinoOption.seltected = true;
    // audioInputSelect.appendChild(snap4ArduinoOption);

    // Create basic Audio Input mode
    var audioInputOption = document.createElement('option');
    audioInputOption.value = "Audio Input";
    audioInputOption.text = "Audio Input"
    audioInputOption.seltected = true;
    audioInputSelect.appendChild(audioInputOption);

    for (let i = 0; i !== deviceInfos.length; ++i) {
        const deviceInfo = deviceInfos[i];
        const option = document.createElement('option');
        option.value = deviceInfo.deviceId;
        if (deviceInfo.kind === 'audioinput') {
            option.text = deviceInfo.label || `microphone ${audioInputSelect.length + 1}`;
            var defaultText = option.text;
            if (defaultText.startsWith("Default") == false) {
                audioInputSourceSelect.appendChild(option);
            }
        } else {
            // console.log('Some other kind of source/device: ', deviceInfo);
        }
    }
    // Add Plotting Option
    const plottingAudioInputOption = document.createElement('option');
    plottingAudioInputOption.value = "Plotting";
    plottingAudioInputOption.text = "Plotting";
    audioInputSourceSelect.appendChild(plottingAudioInputOption);
    // Add None Option
    const noneAudioInputOption = document.createElement('option');
    noneAudioInputOption.value = "Oscillators";
    noneAudioInputOption.text = "Oscillators" // change back if necessary
    audioInputSourceSelect.appendChild(noneAudioInputOption);


    selectors.forEach((select, selectorIndex) => {
        if (Array.prototype.slice.call(select.childNodes).some(n => n.value === values[selectorIndex])) {
            select.value = values[selectorIndex];
        }
    });
}

let selectAudioInputSource = (whichMode) => {
    const mode = audioInputSourceSelect;//document.getElementById("audioSource");
    const currMode = mode.options[mode.selectedIndex].value;
    if (whichMode !== currMode) {
        clearScope();
        // update mode synthetically
        for (var i = 0; i < mode.options.length; i++) {
            const currOption = mode.options[i];
            if (currOption.value === whichMode) {
                mode.selectedIndex = i;
                break;
            }
        }

        if (whichMode !== "Oscillators") {
            enableMic()
        }
    }
}

const onAudioInputSourceSelectChanged = (event) => {
    var mode = audioInputSourceSelect;//document.getElementById("audioSource");
    var modeId = mode.selectedIndex;
    var whichMode = mode.options[modeId].value;
    selectAudioInputSource(whichMode);
}
audioInputSourceSelect.addEventListener("change", onAudioInputSourceSelectChanged, false)
/*
mode.addEventListener('change', (function (event) {
  event.preventDefault();
  selectMode(mode);
}), false);
 */

function handleMouseMove(e) {
    /** If cursor is on animated line, draw on tipCanvas the x,y coordinates of the cursor at the mouse position
     *
     * Written by Rich Nguyen, comment by Alex Li
     * @since 2019.12.19
     * @param {event} e eventObject that contains information about position of mouse
     * @return {void} none
     *
     */
    let mouseX = parseInt(e.clientX - offsetX);
    let mouseY = parseInt(e.clientY - offsetY);

    // Put your mousemove stuff here

    // for (var i = 0; i < dots.length; i++) {
    if (ctx2.isPointInPath(mouseX, mouseY)) {
        tipCtx.clearRect(0, 0, tipCanvas.width, tipCanvas.height);
        // How to extract the dots
        var mode = document.getElementById("audioSource");
        var modeId = mode.selectedIndex;
        var whichMode = mode.options[modeId].value;
        var i = 0;
        if (whichMode == "Oscillators") {
            i = parseInt(mouseX * analyser.frequencyBinCount / c.width);
        }
        else { // Mic/Amp Mode
            var mouseXremap = mapRangeInv([0, 0.001 * ui.dropdownExample.value], [0, 100 * (numSamples / sampleRate) / c.width], mouseX);
            i = parseInt(mouseXremap * analyser.frequencyBinCount / c.width);
        }
        var dot = dots[i];
        // Draw the dots
        tipCanvas.style.left = (dot.x) + "px";
        tipCanvas.style.top = (dot.y - 20) + "px";
        tipCanvas.style.background = ''
        tipCtx.beginPath();
        tipCtx.rect(3, 20, 6, 6);
        tipCtx.fill();
        let tip = "(" + x2time(dot.x) + ", " + y2amplitude(dot.yTip) + ")";
        tipCtx.fillText(tip, 5, 15);
    }
    else {
        tipCanvas.style.visibility = false;
        tipCtx.clearRect(0, 0, tipCanvas.width, tipCanvas.height);
    }
}

function hideAllOscillators() {
    /** Sets visibility of all oscillators to hidden
     * Written by Rich Nguyen, comment by Alex Li
     * @since 2019.12.19
     * @return {void} none
     */
    var oscs = document.getElementsByClassName('oscillator');
    for (let i = 0; i < oscs.length; i++) {
        oscs[i].style.visibility = "hidden";
    }
}

function changeMaxFreqOnAllOscillators(newFreq) {
    /** Sets the maximum frequency of all the oscillators to a new frequency
     * Called by onFreqModeChange()
     * Not functional, wave graph is static, so cannot adjust to showing larger frequency ranges clearly
     * Written by Eric Stein, comment by Alex Li
     * @since 2019.12.20
     * @param {int} newFreq New maximum frequency to set the oscillators to
     * @return {void} none
     *
     */

    var oscs = document.getElementsByClassName('oscillator');
    for (let i = 0; i < oscs.length; i++) {
        let player = oscs[i].player
        let freqSlider = player.freqSlider
        freqSlider.setAttribute('max', newFreq);
        if (oscs[i].player.oscillator.frequency.value > newFreq) {
            setFreq(newFreq, oscs[i].player, oscs[i].player.freqSlider, oscs[i].player.freqBox)
        }

        /** Code Suggestion: Changing Max Frequency
         * ui.dropdownExample.value = 10000 / newMax
         * ctx.clearRect(0, 0, c.width, c.height);
         * createGrid(ctx)
         * drawData()
         */
        //setFreq(oscs[i].player.oscillator.frequency.value, oscs[i].player, oscs[i].player.freqSlider, oscs[i].player.freqBox)
    }
}


let freqDropdown = document.getElementById("freqModeSelect")
function onFreqModeChange() {
    /** Onclick function of check box type element that changes max frequency of oscillators to either 10000 or 1000
     * Written by Eric Stein, comment by Alex Li
     * @since 2019.12.20
     * @return {void} none
     */

    currFreq = freqDropdown.value
    changeMaxFreqOnAllOscillators(currFreq)
}
document.getElementById("freqMode").addEventListener("click", onFreqModeChange, false);
document.getElementById("freqMode").addEventListener("mouseleave", onFreqModeChange, false);
// minor bug: not always called until mouse move is detected on mac google chrome

function showAllOscillators() {
    /** Sets visibility of all oscillators to visible
     * Called by selectMode(selectObj) function to switch to Oscillator mode
     * Written by Rich Nguyen, comment by Alex Li
     * @since 2019.12.20
     * @return {void} none
     */
    var oscs = document.getElementsByClassName('oscillator');
    for (let i = 0; i < oscs.length; i++) {
        oscs[i].style.visibility = "visible";
    }
}


function removeAllOscillators() {
    /** Removes all oscillators
     * Called by selectMode(selectObj) function to switch to recording mode
     * Written by Rich Nguyen, comment by Alex Li
     * @since 2019.12.20
     * @return {void} none
     */
    let oscParentEl = document.getElementById('oscillators');
    let kids = oscParentEl.childNodes;
    while (kids.length > 0) {
        oscParentEl.removeChild(kids[0]);
    }
}

function createAnOscillator() {
    /** Creates one oscillator and adds it to the oscilaltor div
     * Called by the addanother button
     * Written by Rich Nguyen, comment by Alex Li
     * @since 2019.12.20
     * @return {void} none
     */
    var oscParentEl = document.getElementById('oscillators'),
        oscElTxt = document.createElement('label'),
        oscEl = document.createElement('div'),
        onoffBtn = document.createElement('button'),
        removeBtn = document.createElement('button'),
        muteBtn = document.createElement('button'),
        sliderWrapper = document.createElement('div'),
        volumeTxt = document.createElement('label'),
        volumeBox = document.createElement('input'),
        volumeBoxWrapper = document.createElement('div'),
        volumeSlider = document.createElement('input'),
        dividerDiv = document.createElement('div'),
        freqSlider = document.createElement('input'),
        freqTxt = document.createElement('label'),
        lowerFreqBtn = document.createElement('button'),
        freqBox = document.createElement('input'),
        raiseFreqBtn = document.createElement('button'),
        innerLowFreq = document.createElement('span'),
        innerRaisFreq = document.createElement('span'),
        on = document.createElement('span'),
        off = document.createElement('span'),
        thisPlayer = new Object,
        freqboxwrapper = document.createElement('div');

    thisPlayer.context = new AudioContext();
    thisPlayer.oscillator = thisPlayer.context.createOscillator();
    thisPlayer.gainobj = thisPlayer.context.createGain();
    thisPlayer.oscillator.frequency.value = 100;
    thisPlayer.gainobj.gain.value = 1;
    thisPlayer.oscillator.connect(thisPlayer.gainobj);
    thisPlayer.gainobj.connect(thisPlayer.context.destination);
    thisPlayer.playing = false;
    thisPlayer.first = true;
    thisPlayer.freqSlider = freqSlider
    thisPlayer.freqBox = freqBox
    thisPlayer.volumeSlider = volumeSlider;
    thisPlayer.volumeBox = volumeBox;
    thisPlayer.onoffBtn = onoffBtn;

    oscEl.player = thisPlayer

    oscEl.classList.add("oscillator", "osc" + newId);

    oscEl.classList.add("oscillator", "osc" + newId);

    oscEl.setAttribute("data-id", newId);
    oscElTxt.classList.add("oscillatorText")
    oscElTxt.innerHTML = "Tone" + " " + (newId + 1) + ":";

    oscEl.appendChild(oscElTxt);

    onoffBtn.classList.add("toggle-btn", "toggle" + newId);

    on.setAttribute('class', 'on');
    on.innerHTML = "ON"

    onoffBtn.appendChild(on);
    off.setAttribute('class', 'off');
    off.innerHTML = "OFF"
    onoffBtn.appendChild(off);
    onoffBtn.addEventListener("click", (function (event) {
        event.preventDefault();
        this.classList.toggle('switch');
        toggleSound(thisPlayer);
    }), false);
    oscEl.appendChild(onoffBtn);

    removeBtn.classList.add("general-btn");

    removeBtn.innerHTML = "X";
    removeBtn.addEventListener("click", (function (event) {
        event.preventDefault();
        destroyAnOscillator(oscEl, thisPlayer);
    }), false);
    oscEl.appendChild(removeBtn);


    // Add mute button
    muteBtn.classList.add("toggle-btn", "mute-btn", "mute" + newId);
    muteBtn.setAttribute('data-muted', 'false');
    //muteBtn.setAttribute('href','#');
    muteBtn.appendChild(document.createElement('span'));
    muteBtn.innerHTML = "MUTE";

    muteBtn.addEventListener("click", (function (event) {
        event.preventDefault();

        if (muteBtn.getAttribute('data-muted') === 'false') {
            thisPlayer.gainobj.disconnect(thisPlayer.context.destination);
            muteBtn.setAttribute('data-muted', 'true');
            muteBtn.innerHTML = "UNMUTE";
        } else {
            thisPlayer.gainobj.connect(thisPlayer.context.destination);
            muteBtn.setAttribute('data-muted', 'false');
            muteBtn.innerHTML = "MUTE";
        };

    }), false);
    oscEl.appendChild(muteBtn);




    volumeSlider.setAttribute('type', 'range');
    volumeSlider.setAttribute('min', 0);
    volumeSlider.setAttribute('max', 100);
    volumeSlider.setAttribute('step', 1);
    volumeSlider.setAttribute('value', 50);
    volumeSlider.classList.add("volume-slider", "tone-slider", "vs" + newId);
    volumeSlider.addEventListener("input", (function (event) {
        event.preventDefault();
        setVol(volumeSlider.value, thisPlayer, volumeSlider, volumeBox);
    }), false);

    volumeTxt.innerHTML = "AMPLITUDE (V)";
    volumeTxt.classList.add("bold");
    volumeBoxWrapper.appendChild(volumeTxt);
    volumeBoxWrapper.classList.add("volumeBoxWrapper", "volumeBoxWrapper" + newId);

    volumeBox.setAttribute('type', 'text');
    volumeBox.setAttribute('value', 0.5);
    volumeBox.addEventListener("input", (function (event) {
        event.preventDefault();
        let value = volumeBox.value.trim();
        if (!value || value == "" || value == null) {
            value = 0;
            volumeBox.value = 0;
        }
        const newVol = gain2dBFS(value);
        thisPlayer.gainobj.gain.value = dBFS2gain(parseInt(newVol));
        volumeSlider.value = parseInt(newVol);

        if (thisPlayer.playing == true) {
            ui.gain.value = dBFS2gain(parseInt(newVol));
            update(ui.gain);
        }

    }), false);

    volumeBoxWrapper.appendChild(volumeBox);
    sliderWrapper.appendChild(volumeBoxWrapper);
    sliderWrapper.appendChild(volumeSlider);
    sliderWrapper.classList.add('sliderWrapper');

    oscEl.appendChild(sliderWrapper);
    dividerDiv.classList.add()
    oscEl.appendChild(dividerDiv);

    freqTxt.innerHTML = "FREQUENCY (Hz)";
    freqTxt.classList.add("bold");
    freqboxwrapper.classList.add("freqBoxWrapper", "freqboxwrapper" + newId);
    freqboxwrapper.appendChild(freqTxt);
    freqBox.setAttribute('type', 'text');
    freqBox.setAttribute('value', 100);
    freqBox.addEventListener("input", (function (event) {
        event.preventDefault();
        if (freqBox.value.length == 0) {
            freqBox.value = 0;
        }
        setFreq(parseInt(freqBox.value), thisPlayer, freqSlider, freqBox);
    }), false);
    freqboxwrapper.appendChild(freqBox);


    sliderWrapper.appendChild(freqboxwrapper);
    //oscEl.appendChild(freqboxwrapper);


    freqSlider.setAttribute('type', 'range');
    freqSlider.setAttribute('min', 1);
    freqSlider.setAttribute('max', currFreq);
    freqSlider.setAttribute('value', 100);
    freqSlider.classList.add("freq-slider", "tone-slider", "fs" + newId);
    freqSlider.addEventListener("input", (function (event) {
        event.preventDefault();
        setFreq(parseInt(freqSlider.value), thisPlayer, freqSlider, freqBox);
    }), false);


    sliderWrapper.appendChild(freqSlider);
    oscParentEl.appendChild(oscEl);
    newId++;
}


function muteSound(player) {
    /** Unused function
     */
    if (player.context.muted == false) {
        player.context.muted = true;
        player.playing = false;
        //alert(player.context.muted);
    } else {
        player.context.muted = false;
    }


}


function toggleSound(player) {
    /** onclick function of the onoff button
     * If oscillator is playing, suspends audiocontext
     * Else, resume audio context
     * Update ui to change onoff button text
     * Written by Rich Nguyen, comment by Alex Li
     * @since 2019.12.20
     * @param {oscillator} player Oscillator that is being toggled on/off
     */
    if (player.playing) {
        player.context.suspend();
        player.playing = false;

        update(ui);

    } else if (player.first == true) {
        player.oscillator.start(0);
        player.first = false;
        player.playing = true;
        update(ui);
    } else {
        player.context.resume();
        player.playing = true;
        update(ui);

    }
}


function decrementFreq(player, sliderfreqEl, boxfreqEl) {
    /** Decrements the frequency of the ui object and updates ui
     * Unused function
     * Written by Rich Nguyen, comment by Alex Li
     * @since 2019.12.17
     * @param {Oscillator} player oscillator object who's frequency you are incrementing
     * @param {Element} sliderfreqEl frequency slider of oscillator
     * @param {Element} boxfreqEl input box for frequency of oscillator
     * @return {void} none
     */
    player.oscillator.frequency.value--;
    sliderfreqEl.value = parseInt(sliderfreqEl.value) - 1;
    boxfreqEl.value = parseInt(boxfreqEl.value) - 1;
    ui.freq.value = boxfreqEl.value;
    update(ui.freq);
}



function incrementFreq(player, sliderfreqEl, boxfreqEl) {
    /** Increments the frequency of the ui object and updates ui
     * Unused function
     *wRitTen bY rIch nGuyen, comment by aLex lI
     * @since 2019.12.17
     * @param {Oscillator} player oscillator object who's frequency you are incrementing
     * @param {Element} sliderfreqEl frequency slider of oscillator
     * @param {Element} boxfreqEl input box for frequency of oscillator
     * @return {void} none
     */
    player.oscillator.frequency.value++;
    sliderfreqEl.value = parseInt(sliderfreqEl.value) + 1;
    boxfreqEl.value = parseInt(boxfreqEl.value) + 1;
    ui.freq.value = boxfreqEl.value;
    update(ui.freq);
}



function setFreq(newFreq, player, sliderfreqEl, boxfreqEl) {
    /** Sets the frequency of the ui object and updates ui
     * Written by Rich Nguyen, comment by Alex Li
     * @since 2019.12.17
     * @param {Number} newFreq frequency to set oscillator to
     * @param {Oscillator} player oscillator object who's frequency you are incrementing
     * @param {Element} sliderfreqEl frequency slider of oscillator
     * @param {Element} boxfreqEl input box for frequency of oscillator
     * @return {void} none
     */
    player.oscillator.frequency.value = Math.max(newFreq, 0);
    sliderfreqEl.value = newFreq;
    boxfreqEl.value = newFreq;
    // change only if the play is on
    if (player.playing == true) {
        ui.freq.value = newFreq;
        update(ui.freq);
    }

}



function setVol(newVol, player, volumeSlider, volumeBox) {
    /** Sets amplitude of an oscillator
     * Called by input event listener of volumeSlider of oscillator
     * Written by Rich Nguyen, comment by Alex Li
     * @since 2019.12.20
     * @return {void} none
     * @param {int} newVol Integer value of the amplitude to set oscillator to
     * @param {oscillator} player Oscillator that you are changing the volume of
     * @param {slider} slider Slider element of the oscillator
     * @param {input} volumeBox Input element
     */
    player.gainobj.gain.value = dBFS2gain(parseInt(newVol));
    volumeSlider.value = parseInt(newVol);
    volumeBox.value = dBFS2gain(parseInt(newVol));
    if (player.playing == true) {
        ui.gain.value = dBFS2gain(parseInt(newVol));
        update(ui.gain);
    }
}


function dBFS2gain(dbfs) {
    //return Math.pow(10, dbfs / 20);
    return (dbfs / 100).toFixed(2);
}


function gain2dBFS(gain) {
    return (gain * 100);
}


function destroyAnOscillator(El, player) {
    /** Removes oscillator from screen.
     * Iterates through oscillators children and removes them, then removes oscillator from parent div and updates ui
     * Called by remove button
     * Written by Rich Nguyen, comment by Alex Li
     * @since 2019.12.21
     * @param {Oscillator} El Oscillator element that we are destroying
     * @param {Object} player Object with AudioContext data
     * @return {void} none
     *
     */
    var kids = El.childNodes, parent = El.parentElement;
    player.context.close();
    for (var i = 0; i < kids.length; i++) {
        El.removeChild(kids[i]);
    }
    parent.removeChild(El);
    update(ui.gain);
}


function createGrid(ctx) {
    /** Generates the grid lines to display the wave curve
     * Draws on the ctx canvas
     * Called by refreshCanvas() and on startup
     * Written by Rich Nguyen, comment by Alex Li
     * @since 2019.12.21
     * @param {canvas} ctx Canvas the grid lines are being drawn on
     * @return {void} none
     */
    ctx.beginPath();
    ctx.moveTo(0, midPoint.y);
    ctx.lineTo(c.width, midPoint.y);
    ctx.moveTo(midPoint.x, 0);
    ctx.lineTo(midPoint.x, c.height);
    ctx.strokeStyle = 'rgba(0, 0, 0, 1.0)';
    ctx.lineWidth = '0.7';
    ctx.globalCompositeOperation = 'source-over';
    ctx.stroke();
    ctx.closePath();


    ctx.beginPath();
    var gridLineX = midPoint.x - 100;
    while (gridLineX >= 0) {
        ctx.moveTo(gridLineX, 0);
        ctx.lineTo(gridLineX, c.height);
        gridLineX -= 100;

    }

    gridLineX = midPoint.x + 100;
    while (gridLineX <= c.width) {
        ctx.moveTo(gridLineX, 0);
        ctx.lineTo(gridLineX, c.height);
        ctx.fillText(gridLineX / 100 * ui.dropdownExample.value, gridLineX, c.height - 3);
        gridLineX += 100;
    }
    var gridLineY = midPoint.y - 100;
    var unitY = 1;
    while (gridLineY >= 0) {
        ctx.moveTo(0, gridLineY);
        ctx.lineTo(c.width, gridLineY);
        ctx.fillText(unitY, 10, gridLineY);
        gridLineY -= 100;
        unitY += 5;
    }

    ctx.fillText(" 0", 10, midPoint.y);
    gridLineY = midPoint.y + 100;
    unitY = -1;
    while (gridLineY <= c.height) {
        ctx.moveTo(0, gridLineY);
        ctx.lineTo(c.width, gridLineY);
        ctx.fillText(unitY, 10, gridLineY);
        gridLineY += 100;
        unitY -= 5;
    }

    // Fill in the dashlines
    var dashesX = midPoint.x - 20;
    while (dashesX >= 0) {
        ctx.moveTo(dashesX, midPoint.y - 5);
        ctx.lineTo(dashesX, midPoint.y + 5);
        dashesX -= 20;
    }
    while (dashesX <= c.width) {
        ctx.moveTo(dashesX, midPoint.y - 5);
        ctx.lineTo(dashesX, midPoint.y + 5);
        dashesX += 20;
    }
    var dashesY = midPoint.y - 20;
    while (dashesY >= 0) {
        ctx.moveTo(midPoint.x - 5, dashesY);
        ctx.lineTo(midPoint.x + 5, dashesY);
        dashesY -= 20;
    }
    dashesY = midPoint.y + 20;
    while (dashesY <= c.height) {
        ctx.moveTo(midPoint.x - 5, dashesY);
        ctx.lineTo(midPoint.x + 5, dashesY);
        dashesY += 20;
    }

    ctx.stroke();

}

/**
 * animate is used to update the graph when streaming is on (i.e. the microphone is being used)
 * Written by Rich Nguyen
 * Comment by Eric Stein
 * @since 2/12/20
 */
function animate() {

    if (streaming === true && ui.freeze.value === false) {
        analyser.getByteTimeDomainData(timeDomain);
        window.requestAnimationFrame(animate);
    }

    drawData();

    // gainNode.gain.value = ui.gain.value;
}

const clearScope = () => {
    ctx2.clearRect(0, 0, c.width, c.height);
}

/**
 * drawData is used to update the graph with all relevant waves
 * Written by Rich Nguyen, Modified by Eric Stein
 * Comment by Eric Stein
 * @since 2/12/20
 */
function drawData() {
    const selectedAudioInput = audioInputSourceSelect.options[audioInputSourceSelect.selectedIndex];
    if (selectedAudioInput === undefined) return;
    let selectedAudioInputValue = selectedAudioInput.value;
    if (selectedAudioInputValue === "Oscillators") {
        streaming = false
    }
    const plotting = selectedAudioInputValue === "Plotting";

    dots = [];
    ctx2.translate(-previousTranslate.x, -previousTranslate.y);
    if (!plotting) {
        clearScope();
    }

    ctx2.translate(ui.horizOffset.value, ui.vertOffset.value);
    ctx2.beginPath();


    // Get all needed on, gain, and freq.


    var gainArr = [];
    var freqArr = [];
    var idx = 0;
    // create osc data
    var oscs = document.getElementsByClassName('oscillator');
    // Check to see how many element.
    var numOsc = oscs.length;
    for (var i = 0; i < numOsc; i++) {
        // Check if the button is on
        if (oscs[i].getElementsByClassName("toggle-btn switch").length > 0) {
            //Get the Amplitude Gain
            var volumeSlider = oscs[i].getElementsByClassName("volume-slider")[0].value;
            gainArr[idx] = dBFS2gain(parseInt(volumeSlider));
            var freqSlider = oscs[i].getElementsByClassName("freq-slider")[0].value;
            freqArr[idx] = Math.max(freqSlider, 0);
            idx++;
        }
    }
    // create Snap! data
    if (currentSnapiFrame !== null) {
        var snapSounds = currentSnapiFrame.getSounds()
        for (var i = 0; i < snapSounds.length; i++) {
            let snapSoundData = snapSounds[i];
            if (snapSoundData !== null) {
                gainArr[idx] = snapSoundData.gain
                freqArr[idx] = snapSoundData.freq
                idx++
            }
        }
        // streaming = true;
    }

    var itemWeight = 1; //1 / idx;

    //console.log(freqArr);
    for (var i = 0; i <= analyser.frequencyBinCount; i++) {
        var index = i; // + analyser.frequencyBinCount / 2;
        var yTip = 0;
        var xc = 0;
        var yc = 0;
        if (streaming == true) {


            var height = c.height * timeDomain[i] / 256;
            var offset = c.width * (analyser.frequencyBinCount / (analyser.frequencyBinCount - 1)) * i / analyser.frequencyBinCount;

            // analyser.getByteTimeDomainData(timeDomain);


            xc = i * (c.width / analyser.frequencyBinCount);
            yc = ui.gain.value * ((timeDomain[index] / 255) - 0.5) * 200 / (ui.volts.value);
            yTip = yc;
            yc += c.height / 2;

            // apply dc offset
            //yc = ui.dc_offset.value*-1 + yc;

            xc = mapRange([0, 0.001 * ui.dropdownExample.value], [0, 100 * (numSamples / sampleRate) / c.width], xc);
            //xc = mapRange([0, 0.00015 * ui.dropdownExample.value], [0, 100 * (numSamples / sampleRate) / c.width], xc);
            //xc = mapRange([0, 0.000015 * ui.dropdownExample.value], [0, 100 * (numSamples / sampleRate) / c.width], xc);

            // shift graph to middle of oscilloscpe

            // xc += c.width / 2;

            // TEST: ctx2.lineTo(xc, Math.random() * 1200 - 600); i.e. if (plotting) set lineTo y=plot[xc] something // TODO: plotting
            // xc:
            // yc0 = 1, yc225=-1

            if (plotting) {
                for (var customPlotIndex = 0; customPlotIndex < customPlot.length; customPlotIndex++) {
                    const point = customPlot[customPlotIndex];
                    ctx2.fillRect(point[0], point[1], 4, 3.8)
                }
                customPlot.splice(0, customPlot.length);
            } else {
                ctx2.lineTo(xc, yc);
            }

        } else {
            /** CODE SUGGESTION: Changing Max Frequency
             *  var MAX_FREQ = 10000 / ui.dropdownExample.value
             *  var STEP = 0.01 / MAX_FREQ
             */
            // console.log(index);
            xc = i * (c.width / analyser.frequencyBinCount);

            //dropdown value also needs mapping
            //var scaledRangeValue = mapRange([1, 2], [1, 3], ui.dropdownExample.value);

            // 100 pixels per division
            var amplitude = 100 / ui.volts.value;

            //so total length in seconds of graph is sampleRate*numSamples
            //console.log("total length:", numSamples/sampleRate); //=0.0053333seconds, so 1 pixel represents 0.00533/width seconds
            //by default 100px represents 100*0.00533/width  = ??? seconds
            //we want it to represent 1ms
            yc = 0;
            var amp = 0;
            for (var idx = 0; idx < gainArr.length; idx++) {
                if (gainArr[idx] !== null) {
                    amp = -amplitude * Math.sin(2 * Math.PI * xc);

                    /** CODE SUGGESTION: Change Max Frequency
                     * var ycItem = -amplitude * Math.sin(2 * Math.PI * time * freqArr[k] * STEP);
                     * Comment out line below this comment
                     */
                    var ycItem = -amplitude * Math.sin(2 * Math.PI * xc * freqArr[idx] * 0.00001 * ui.dropdownExample.value); //0.00001 is the number of seconds we want a pixel to represent, ie 1ms / 100
                    if (ui.inputType.value == 3) {
                        if (ycItem > 0) ycItem = amplitude;
                        else ycItem = -amplitude;
                    }
                    //apply gain
                    ycItem *= gainArr[idx];
                    // Combine signal;
                    yc += ycItem * itemWeight;
                } else {
                    // console.log("NULL; not drawing data")
                }
            }

            //center vertically
            yTip = yc;
            yc = c.height / 2 + yc;

            ctx2.lineTo(xc, yc);
        }
        dots.push({
            x: xc,
            y: yc,
            yTip: yTip
        });
    }

    previousTranslate = { x: ui.horizOffset.value, y: ui.vertOffset.value };
    // Use multiple stroke for smoothing effect
    ctx2.strokeStyle = 'rgba(0, 0, 0, 0.5)';
    ctx2.lineWidth = 1;
    ctx2.stroke();

    ctx2.strokeStyle = 'rgba(0, 0, 0,0.5)';
    ctx2.lineWidth = 3;
    ctx2.stroke();
    ctx2.strokeStyle = 'rgba(0, 0, 0, 0.3)';
    ctx2.lineWidth = 4;
    ctx2.stroke();

}

function y2amplitude(y) {
    return -(y / 100).toFixed(2);
}

function x2time(x) {
    return (x / 100 * ui.dropdownExample.value).toFixed(1);
}


function handleError(error) {
    console.log('navigator.MediaDevices.getUserMedia error: ', error.message, error.name);
}


function isNumber(n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
}


function trackError(message, file, line) {
    // console.log(message, line, file);
}


window.onerror = function (message, file, line) {
    // trackError(message, line, file);
    //ga('send', 'event', 'JavaScript Error', message, file + ": Line " + line, { 'nonInteraction': 1 });
}

var elmRoot = document.getElementById("root");
var logoBtn = document.getElementById("tunescope");
var target = document.getElementById("header");
var slt = document.getElementById("selectDiv");
slt.style.opacity = 1;
var currColor = target.style.backgroundColor;
var elmMain = document.getElementById("mainBody");


var text1 = window.location.href;

function copyTextToClipboard(text) {
    var textArea = document.createElement("textarea");

    //
    // *** This styling is an extra step which is likely not required. ***
    //
    // Why is it here? To ensure:
    // 1. the element is able to have focus and selection.
    // 2. if element was to flash render it has minimal visual impact.
    // 3. less flakyness with selection and copying which **might** occur if
    //    the textarea element is not visible.
    //
    // The likelihood is the element won't even render, not even a flash,
    // so some of these are just precautions. However in IE the element
    // is visible whilst the popup box asking the user for permission for
    // the web page to copy to the clipboard.
    //

    // Place in top-left corner of screen regardless of scroll position.
    textArea.style.position = 'fixed';
    textArea.style.top = 0;
    textArea.style.left = 0;

    // Ensure it has a small width and height. Setting to 1px / 1em
    // doesn't work as this gives a negative w/h on some browsers.
    textArea.style.width = '2em';
    textArea.style.height = '2em';

    // We don't need padding, reducing the size if it does flash render.
    textArea.style.padding = 0;

    // Clean up any borders.
    textArea.style.border = 'none';
    textArea.style.outline = 'none';
    textArea.style.boxShadow = 'none';

    // Avoid flash of white box if rendered for any reason.
    textArea.style.background = 'transparent';


    textArea.value = text;

    document.body.appendChild(textArea);

    textArea.select();

    try {
        var successful = document.execCommand('copy');
        var msg = successful ? 'successful' : 'unsuccessful';
        console.log('Copying text command was ' + msg);
        alert("URL sucessfully copied: " + text);
    } catch (err) {
        console.log('Oops, unable to copy');
    }

    document.body.removeChild(textArea);
}

let createCopyURLButton = () => {
    let cpUrlBtn = document.createElement('button');
    cpUrlBtn.classList.add("toggle-btn", "collapItm");
    cpUrlBtn.appendChild(document.createElement('span'));
    cpUrlBtn.innerHTML = "Copy URL";
    cpUrlBtn.addEventListener("click", (function () {
        copyTextToClipboard(window.location.href);

    })
    );
    return cpUrlBtn;
}

// let copyUrlBtn = createCopyURLButton();
// slt.appendChild(copyUrlBtn);



/*var optionsButton = document.createElement('button');
optionsButton.classList.add("toggle-btn", "freeze-btn");
optionsButton.id = 'toggleMenu';
optionsButton.innerHTML = "Options";
slt.appendChild(optionsButton);*/


var collapseButton = document.createElement('button');
collapseButton.classList.add("btn", "btn-light", "mx-1");
collapseButton.id = 'collapseMenu';
collapseButton.innerHTML = "<";
slt.appendChild(collapseButton);
var currTheme = 'light';




/*function toggle_visibility() {
       var itms = document.querySelectorAll(".collapItm");
       for(var i = 0; i < itms.length; i++)
        {
            if(itms[i].style.display == 'none')
                itms[i].style.display = 'block';
            else
                itms[i].style.display = 'none';

        }
        if(collapseButton.classList.contains('btn-success'))
        {
            collapseButton.classList.remove('btn-success');
            collapseButton.classList.add('btn-secondary');
        }else{
            collapseButton.classList.remove('btn-secondary');
            collapseButton.classList.add('btn-success');
        }
        if(collapseButton.innerHTML == "˅")
        {
            collapseButton.innerHTML = "˃";
        }else{
            collapseButton.innerHTML = "˅"
        }

    }*/

let createExpandButton = () => {
    let expdBtn = document.createElement('button');
    expdBtn.classList.add("btn", "bg-light", "mt-3", "ml-1");
    expdBtn.appendChild(document.createElement('span'));
    expdBtn.innerHTML = ">";
    expdBtn.addEventListener("click", (function () {
        expdBtn.remove();
        menuCollapsed = false;
        if (currentSnapiFrame != null) {
            if (currentSnapiFrame.expanded) {
                setTimeout(function () {
                    currentSnapiFrame.expand();
                }, 100);
            }
        }

        elmMain.style.height = '90%';
        elmMain.style.top = '10%';
        target.style.width = '100%';
        target.style.height = '10%';
        target.style.backgroundColor = currColor;
        target.style.boxShadow = '0px 1px 10px #999';
        setTimeout(function () {
            slt.style.opacity = '1';
            slt.style.right = '5%';
            slt.style.display = '';
        }, 200);
        if (currTheme == 'light') {
            logoBtn.style.content = 'url(TuneScope.png)';
        } else if (currTheme == 'dark') {
            logoBtn.style.content = 'url(darkTuneScope.png)';
        }
        logoBtn.style.width = '18vw';
        logoBtn.classList.remove("mt-3");
    })
    );
    return expdBtn;
}






//setTimeout(function () { currentSnapiFrame.setFlatTheme(); }, 5000);

function shuffle(o) {
    for (var j, x, i = o.length; i; j = Math.floor(Math.random() * i), x = o[--i], o[i] = o[j], o[j] = x);
    return o;
}

//var elmLogo = document.getElementsByClassName('TuneScopeLogo');


function leftCollapse() {

    console.log('collpasing');
    //target.style.opacity = '0';

    //normal -> collapsed
    if (slt.style.opacity > 0) {
        menuCollapsed = true;
        slt.style.opacity = '0';
        slt.style.right = '30%';
        setTimeout(function () {
            slt.style.display = 'none';

        }, 1000);
        target.style.width = '18%';
        target.style.height = '5%';

        target.style.backgroundColor = '#ffffff00';
        target.style.boxShadow = 'none';
        console.log(logoBtn.style.content);
        if (currTheme == 'light') {
            logoBtn.style.content = 'url(LtMin.png)';
        } else if (currTheme == 'dark') {
            logoBtn.style.content = 'url(DkMin.png)';
        }
        logoBtn.style.width = '8.8vw';
        logoBtn.classList.add("mt-3");
        setTimeout(function () {
            elmMain.style.height = '95%';
            elmMain.style.top = '5%';
        }, 200);
        if (currentSnapiFrame != null) {
            if (currentSnapiFrame.expanded) {
                setTimeout(function () {
                    currentSnapiFrame.expand();
                }, 100);
            }
        }

        var expdButton = createExpandButton();
        document.getElementById('preamble').appendChild(expdButton);

    }
    else
    //collapsed to normal
    {
        menuCollapsed = false;
        if (currentSnapiFrame != null) {
            if (currentSnapiFrame.expanded) {
                setTimeout(function () {
                    currentSnapiFrame.expand();
                }, 100);
            }
        }


        elmMain.style.height = '90%';
        elmMain.style.top = '10%';
        target.style.width = '100%';
        target.style.height = '10%';
        target.style.backgroundColor = currColor;
        target.style.boxShadow = '0px 1px 10px #999';
        setTimeout(function () {
            slt.style.opacity = '1';
            slt.style.right = '5%';
            slt.style.display = '';
        }, 200);
        if (currTheme == 'light') {
            logoBtn.style.content = 'url(TuneScope.png)';
        } else if (currTheme == 'dark') {
            logoBtn.style.content = 'url(darkTuneScope.png)';
        }
        logoBtn.style.width = '18vw';
        logoBtn.classList.remove("mt-3");
    }
    //
}



leftCollapse();
/*function toggle_visibility() {
       var itms = document.querySelectorAll(".collapItm");
       for(var i = 0; i < itms.length; i++)
        {
            if(itms[i].style.display == 'none')
                itms[i].style.display = 'block';
            else
                itms[i].style.display = 'none';

        }
        if(collapseButton.classList.contains('btn-success'))
        {
            collapseButton.classList.remove('btn-success');
            collapseButton.classList.add('btn-secondary');
        }else{
            collapseButton.classList.remove('btn-secondary');
            collapseButton.classList.add('btn-success');
        }
        if(collapseButton.innerHTML == "˅")
        {
            collapseButton.innerHTML = "˃";
        }else{
            collapseButton.innerHTML = "˅"
        }

    }*/
var itms = document.querySelectorAll(".collapItm");


document.addEventListener('DOMContentLoaded', function () {

    collapseButton.addEventListener('click', function () { leftCollapse(); });
    var checkbox = document.querySelector('input[type="checkbox"]');

    checkbox.addEventListener('change', function () {


        var elmMain = document.querySelectorAll("[id='mainBody']");
        var elmHeader = document.querySelectorAll("[id='header']");


        if (checkbox.checked) {
            logoBtn.style.content = 'url(darkTuneScope.png)';
            console.log('Changed to Dark Mode');
            currTheme = 'dark';
            elmRoot.style.backgroundColor = '#313131';
            for (var i = 0; i < elmMain.length; i++)
                elmMain[i].style.backgroundColor = '#313131';
            document.body.style.color = '#ffffff';
            for (var i = 0; i < elmHeader.length; i++) {
                elmHeader[i].style.backgroundColor = '#525252';
                elmHeader[i].style.boxShadow = '0px 1px 10px #999';
            }
            setTimeout(function () { currentSnapiFrame.setDarkTheme(); }, 500);


        } else {

            logoBtn.style.content = 'url(TuneScope.png)';
            console.log('Changed to Light Mode');
            currTheme = 'light';
            elmRoot.style.backgroundColor = '#ffffff';
            for (var i = 0; i < elmMain.length; i++) {
                elmMain[i].style.backgroundColor = '#ffffff';
            }
            document.body.style.color = '#232d4b';
            for (var i = 0; i < elmHeader.length; i++) {
                elmHeader[i].style.backgroundColor = '#f0f0f5';
                elmHeader[i].style.boxShadow = '0px 1px 10px #999';
            }
            setTimeout(function () { currentSnapiFrame.setFlatTheme(); }, 500);


        }
        currColor = target.style.backgroundColor;
    });

    var elmPream = document.getElementById('preamble');

    //Removed function on 5/3/2021
    //logoBtn.addEventListener('click',  function(){leftCollapse();});



    /*optionsButton.addEventListener('click', function toggle_visibility() {

       for(var i = 0; i < itms.length; i++)
        {
            if(itms[i].style.visibility == 'hidden')
            {
                itms[i].style.opacity = '1';
                itms[i].style.visibility = 'visible';


            }
            else
            {
                itms[i].style.opacity = '0.01';

                itms[i].style.visibility = 'hidden';



            }
        }

    });*/

});

// If you want to remove it from the page after the fadeout
//target.addEventListener('transitionend', () => target.remove(), false);

/*
document.addEventListener('DOMContentLoaded', function () {
  var logoBtn = document.getElementById("tunescope");

  logoBtn.addEventListener('click', function () {
        var fadeTarget = document.getElementById("selectDiv");
        //fadeTarget.style.display = 'none';
        var fadeEffect = setInterval(function () {
            if (!fadeTarget.style.opacity) {
                fadeTarget.style.opacity = 1;
            }
            if (fadeTarget.style.opacity > 0) {
                fadeTarget.style.opacity -= 0.1;
            } else {
                clearInterval(fadeEffect);
            }

        }, 200);


    });
});*/
// !function (t) { function n(i) { if (e[i]) return e[i].exports; var o = e[i] = { i: i, l: !1, exports: {} }; return t[i].call(o.exports, o, o.exports, n), o.l = !0, o.exports } var e = {}; n.m = t, n.c = e, n.d = function (t, e, i) { n.o(t, e) || Object.defineProperty(t, e, { configurable: !1, enumerable: !0, get: i }) }, n.n = function (t) { var e = t && t.__esModule ? function () { return t.default } : function () { return t }; return n.d(e, "a", e), e }, n.o = function (t, n) { return Object.prototype.hasOwnProperty.call(t, n) }, n.p = "", n(n.s = 0) }([function (t, n, e) { e(1), t.exports = e(4) }, function (t, n, e) { "use strict"; var i = Object.assign || function (t) { for (var n = 1; n < arguments.length; n++) { var e = arguments[n]; for (var i in e) Object.prototype.hasOwnProperty.call(e, i) && (t[i] = e[i]) } return t }; e(2); var o = e(3); !function (t) { function n(t) { return t = i({}, c, t), function (t) { return ["nfc-top-left", "nfc-top-right", "nfc-bottom-left", "nfc-bottom-right"].indexOf(t) > -1 }(t.positionClass) || (console.warn("An invalid notification position class has been specified."), t.positionClass = c.positionClass), t.onclick && "function" != typeof t.onclick && (console.warn("Notification on click must be a function."), t.onclick = c.onclick), "number" != typeof t.showDuration && (t.showDuration = c.showDuration), (0, o.isString)(t.theme) && 0 !== t.theme.length || (console.warn("Notification theme must be a string with length"), t.theme = c.theme), t } function e(t) { return t = n(t), function () { var n = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, e = n.title, i = n.message, c = r(t.positionClass); if (!e && !i) return console.warn("Notification must contain a title or a message!"); var a = (0, o.createElement)("div", "ncf", t.theme); if (!0 === t.closeOnClick && a.addEventListener("click", function () { return c.removeChild(a) }), t.onclick && a.addEventListener("click", function (n) { return t.onclick(n) }), t.displayCloseButton) { var s = (0, o.createElement)("button"); s.innerText = "X", !1 === t.closeOnClick && s.addEventListener("click", function () { return c.removeChild(a) }), (0, o.append)(a, s) } if ((0, o.isString)(e) && e.length && (0, o.append)(a, (0, o.createParagraph)("ncf-title")(e)), (0, o.isString)(i) && i.length && (0, o.append)(a, (0, o.createParagraph)("nfc-message")(i)), (0, o.append)(c, a), t.showDuration && t.showDuration > 0) { var l = setTimeout(function () { c.removeChild(a), 0 === c.querySelectorAll(".ncf").length && document.body.removeChild(c) }, t.showDuration); (t.closeOnClick || t.displayCloseButton) && a.addEventListener("click", function () { return clearTimeout(l) }) } } } function r(t) { var n = document.querySelector("." + t); return n || (n = (0, o.createElement)("div", "ncf-container", t), (0, o.append)(document.body, n)), n } var c = { closeOnClick: !0, displayCloseButton: !1, positionClass: "nfc-top-right", onclick: !1, showDuration: 3500, theme: "success" }; t.createNotification ? console.warn("Window already contains a create notification function. Have you included the script twice?") : t.createNotification = e }(window) }, function (t, n, e) { "use strict"; !function () { function t(t) { this.el = t; for (var n = t.className.replace(/^\s+|\s+$/g, "").split(/\s+/), i = 0; i < n.length; i++)e.call(this, n[i]) } if (!(void 0 === window.Element || "classList" in document.documentElement)) { var n = Array.prototype, e = n.push, i = n.splice, o = n.join; t.prototype = { add: function (t) { this.contains(t) || (e.call(this, t), this.el.className = this.toString()) }, contains: function (t) { return -1 != this.el.className.indexOf(t) }, item: function (t) { return this[t] || null }, remove: function (t) { if (this.contains(t)) { for (var n = 0; n < this.length && this[n] != t; n++); i.call(this, n, 1), this.el.className = this.toString() } }, toString: function () { return o.call(this, " ") }, toggle: function (t) { return this.contains(t) ? this.remove(t) : this.add(t), this.contains(t) } }, window.DOMTokenList = t, function (t, n, e) { Object.defineProperty ? Object.defineProperty(t, n, { get: e }) : t.__defineGetter__(n, e) }(Element.prototype, "classList", function () { return new t(this) }) } }() }, function (t, n, e) { "use strict"; Object.defineProperty(n, "__esModule", { value: !0 }); var i = n.partial = function (t) { for (var n = arguments.length, e = Array(n > 1 ? n - 1 : 0), i = 1; i < n; i++)e[i - 1] = arguments[i]; return function () { for (var n = arguments.length, i = Array(n), o = 0; o < n; o++)i[o] = arguments[o]; return t.apply(void 0, e.concat(i)) } }, o = (n.append = function (t) { for (var n = arguments.length, e = Array(n > 1 ? n - 1 : 0), i = 1; i < n; i++)e[i - 1] = arguments[i]; return e.forEach(function (n) { return t.appendChild(n) }) }, n.isString = function (t) { return "string" == typeof t }, n.createElement = function (t) { for (var n = arguments.length, e = Array(n > 1 ? n - 1 : 0), i = 1; i < n; i++)e[i - 1] = arguments[i]; var o = document.createElement(t); return e.length && e.forEach(function (t) { return o.classList.add(t) }), o }), r = function (t, n) { return t.innerText = n, t }, c = function (t) { for (var n = arguments.length, e = Array(n > 1 ? n - 1 : 0), c = 1; c < n; c++)e[c - 1] = arguments[c]; return i(r, o.apply(void 0, [t].concat(e))) }; n.createParagraph = function () { for (var t = arguments.length, n = Array(t), e = 0; e < t; e++)n[e] = arguments[e]; return c.apply(void 0, ["p"].concat(n)) } }, function (t, n) { }]);/* Load WebAudioFontPlayer and define functions*/
